'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var app = {

	settings: {},

	vars: {
		activated: ''
	},

	init: function init() {
		this.isTouchScreen();
		this.urlParams();
		this.initGlobalExtensions();
		this.initLocalExtensions($('body'));
	},

	parse: function parse($context) {
		this.initLocalExtensions($context);
	},

	initGlobalExtensions: function initGlobalExtensions() {
		var t = this;
		for (var globalExt in t.globalExt) {
			if (!app.obj[globalExt]) {
				app.obj[globalExt] = new t.globalExt[globalExt]();
			}
		}
	},

	initLocalExtensions: function initLocalExtensions($context) {
		var t = this;
		for (var ext in t.ext) {
			var $els = $context.findOrSelf('.js-' + ext);
			$els.each(function () {
				var fn = new t.ext[ext]($(this));

				$(this).data('obj_' + ext, fn);

				if (app.obj[ext] === undefined) app.obj[ext] = [];
				if ($(this).data('objectName')) {
					app.obj[ext][$(this).data('objectName')] = fn;
				} else {
					app.obj[ext].push(fn);
				}
			});
		}
	},

	isTouchScreen: function isTouchScreen() {
		var deviceAgent = navigator.userAgent.toLowerCase();
		var touchEnabled = 'ontouchstart' in window || navigator.maxTouchPoints;
		var $html = $('html');
		var no = 'screen--no-touch';
		var is = 'screen--is-touch';
		var no_touch = $html.hasClass(no);
		var is_touch = $html.hasClass(is);

		if ((deviceAgent.match(/(iphone|ipod|ipad)/) || deviceAgent.match(/(android)/) || deviceAgent.match(/(iemobile)/) || deviceAgent.match(/iphone/i) || deviceAgent.match(/ipad/i) || deviceAgent.match(/ipod/i) || deviceAgent.match(/blackberry/i) || deviceAgent.match(/bada/i)) && touchEnabled) {
			if (!is_touch) $html.addClass(is);
		} else if (!no_touch) {
			$html.addClass(no);
		}
	},

	urlParams: function urlParams() {
		var search = document.location.search;
		app.vars.urlParam = {};
		if (search.length > 0) {
			$.each(document.location.search.substr(1).split('&'), function (c, q) {
				var i = q.split('=');
				app.vars.urlParam[i[0].toString()] = i[1] ? i[1].toString() : true;
			});
		}
	},

	getParam: function getParam(name, url) {
		var string = url || location.href;
		var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(string); //window.location.href
		if (results == null) {
			return null;
		} else {
			return results[1] || 0;
		}
	},

	ext: {},
	globalExt: {},
	obj: {}
};

$(function () {
	app.init();
});

$.fn.findOrSelf = function (selector) {
	return this.find(selector).add(this.filter(selector));
};

$(document).ready(function () {

	dotify();

	$(window).bind('orientationchange', function () {
		dotify();
	});
	$(window).on('resize', function () {
		dotify();
	});
});

function dotify() {
	$('.js-dotdotdot').dotdotdot();
	$('.js-dotdotdot').parent().addClass('cropped');

	setTimeout(function () {
		$('.js-dotdotdot').dotdotdot();
	}, 300);
}

app.globalExt['callback-overlay'] = function () {
	var api = {};

	var init = function init() {
		$(document).on('click', 'a[href="#callback-overlay"]', openOverlay);
	};

	var openOverlay = function openOverlay(e) {
		e.preventDefault();

		var scrollTop = parseInt($(document).scrollTop(), 10);

		$('.overlay--callback').animate({ marginRight: 0 }, 300);
		$('.overlayshade').addClass('active');

		$('body').addClass('noscroll');
		$('body').css({
			position: 'fixed',
			height: '100vh',
			width: '100vw',
			marginTop: -scrollTop
		});

		if (window.innerWidth < 1023) {
			setTimeout(function () {
				$('body').css({
					marginTop: 0
				});
			}, 300);
		}

		$('body').data('tops', scrollTop);
	};

	init();return api;
};

app.globalExt['global-structure'] = function () {
	var api = {};

	var init = function init() {};

	init();return api;
};

/*
	Smooth Zoom Pan - jQuery Image Viewer
 	Copyright (c) 2011-12 Ramesh Kumar
	http://codecanyon.net/user/VF
	
	Version:	1.6.9
	RELEASE:	09 SEP 2011
	UPDATE:		27 FEB 2013
	
	Built using:
	jQuery 		version:1.9.1	http://jquery.com/
	Modernizr 	version:2.5.3	http://www.modernizr.com/
	MouseWheel	version:3.0.6	http://brandonaaron.net/code/mousewheel/docs
	
*/

app.globalExt['smoothZoom'] = function () {
	var api = {};

	var init = function init() {
		//(function ($, window, document) {

		/*****************************************************************************
  	Default settings:
  	For detailed description of individual parameters, see the help document
  ******************************************************************************/
		var defaults = {

			width: '', //Width of the view area [480, '480px', '100%']
			height: '', //Height of the view area [480, '480px', '100%']

			initial_ZOOM: '', //Initial zoom level to start with (in percentage) [100]
			initial_POSITION: '', //Initial location to be focused in pixel value [150,150 or 150 150]

			animation_SMOOTHNESS: 5.5, //Ease or smoothness of all movements [Any number from 0]				
			animation_SPEED_ZOOM: 5.5, //Speed of zoom movements [Any number from 0] 
			animation_SPEED_PAN: 5.5, //Speed of pan movements [Any number from 0] 

			zoom_MAX: 800, //Maximum limit for zooming (in percentage)
			zoom_MIN: '', //Minimum limit for zooming (in percentage)
			zoom_SINGLE_STEP: false, //To reach maximum and minimum zoom levels in single click 
			zoom_OUT_TO_FIT: true, //To allow image to be zoomed out with whitespace on sides
			zoom_BUTTONS_SHOW: true, //To enable/disable the + and - buttons

			pan_BUTTONS_SHOW: true, //To enable/disable the arrow and reset buttons
			pan_LIMIT_BOUNDARY: true, //To allow/restrict moving the image beyond boundaries
			pan_REVERSE: false,

			reset_ALIGN_TO: 'center center', //Image can be aligned to desired position on reset. Example: 'Top Left'
			reset_TO_ZOOM_MIN: true, //How it should behave if zoom_MIN value set and while clicking reset button, 

			button_HOLDER: false, //Buttons parent element
			button_SIZE: 18, //Button width and height (in pixels)
			button_SIZE_TOUCH_DEVICE: 30, //Button width and height (in pixels) on touch devices
			button_COLOR: '#FFFFFF', //Button color in hexadecimal
			button_BG_COLOR: '#000000', //Button set's background color in hexadecimal
			button_BG_TRANSPARENCY: 55, //Background transparency (in percentage)
			button_AUTO_HIDE: false, //To hide the button set when mouse moved outside the view area
			button_AUTO_HIDE_DELAY: 1, //Auto hide delay time in seconds
			button_ALIGN: 'bottom right', //Button set can be aligned to any side or center
			button_MARGIN: 10, //Space between button set and view port's edge
			button_ROUND_CORNERS: true, //To enable disable roundness of button corner

			touch_DRAG: true, //Enable/disable the dragability of image (touch)
			mouse_DRAG: true, //Enable/disable the dragability of image (mouse)
			mouse_WHEEL: true, //Enable/disable mousewheel zoom
			mouse_WHEEL_CURSOR_POS: true, //Enable/disable position sensitive mousewheel zoom
			mouse_DOUBLE_CLICK: true, //Enable/disable zoom action with double click

			background_COLOR: '#FFFFFF', //Background colour of image container
			border_SIZE: 1, //Border size of view area
			border_COLOR: '#000000', //Border color of view area
			border_TRANSPARENCY: 10, //Border transparency of view area

			image_url: '', //Set url or image to be zoomed
			image_original_width: '', //Original width of main image
			image_original_height: '', //Original height of main image
			container: '', //Set container element of image (id of container)

			on_IMAGE_LOAD: '', //To Call external function immediatly after image loaded
			on_ZOOM_PAN_UPDATE: '', //To Call external function for each zoom, pan animation frame
			on_ZOOM_PAN_COMPLETE: '', //To Call external function whenever zoom, pan animation completes
			on_LANDMARK_STATE_CHANGE: '', //To Call external function whenever the zoom leval crosses global "data-show-at-zoom" value

			use_3D_Transform: true, //To enable / disable Hardware acceleration on webkit browsers

			responsive: false, //To enable / disable Responsive / fluid layout
			responsive_maintain_ratio: true, //To maintain view area width/height ratio or not
			max_WIDTH: '', //Maximum allowed width of view area (helpful when 'width' parameter set with % and need limit)
			max_HEIGHT: '', //Maximum allowed height of view area (helpful when 'height' parameter set with % and need limit)

			allow_PINCH_ZOOM: true //allow zooming with touch pinch
		};

		function Zoomer($elem, params) {

			var self = this;
			this.$elem = $elem;
			this.$map = $elem.parent();
			var op = $.extend({}, defaults, params);

			/**********************************************************
   Option values verified and formated if needed
   **********************************************************/
			this.sW = op.width;
			this.sH = op.height;

			this.init_zoom = op.initial_ZOOM / 100;
			this.init_pos = op.initial_POSITION.replace(/,/g, ' ').replace(/\s{2,}/g, ' ').split(' ');

			this.zoom_max = op.zoom_MAX / 100;
			this.zoom_min = op.zoom_MIN / 100;

			this.zoom_single = checkBoolean(op.zoom_SINGLE_STEP);
			this.zoom_fit = checkBoolean(op.zoom_OUT_TO_FIT);
			this.zoom_speed = 1 + ((op.animation_SPEED === 0 || op.animation_SPEED ? op.animation_SPEED : op.animation_SPEED_ZOOM) + 1) / 20;
			this.zoom_show = checkBoolean(op.zoom_BUTTONS_SHOW);

			this.pan_speed_o = op.animation_SPEED === 0 || op.animation_SPEED ? op.animation_SPEED : op.animation_SPEED_PAN;
			this.pan_show = checkBoolean(op.pan_BUTTONS_SHOW);
			this.pan_limit = checkBoolean(op.pan_LIMIT_BOUNDARY);
			this.pan_rev = checkBoolean(op.pan_REVERSE);

			this.reset_align = op.reset_ALIGN_TO.toLowerCase().split(' ');
			this.reset_to_zmin = checkBoolean(op.reset_TO_ZOOM_MIN);

			if (supportsTouch) {
				this.bu_size = parseInt(op.button_SIZE_TOUCH_DEVICE / 2) * 2;
			} else {
				this.bu_size = parseInt(op.button_SIZE / 2) * 2;
			}
			this.bu_color = op.button_COLOR;
			this.bu_bg = op.button_BG_COLOR;
			this.bu_bg_alpha = op.button_BG_TRANSPARENCY / 100;
			this.bu_icon = op.button_ICON_IMAGE;
			this.bu_auto = checkBoolean(op.button_AUTO_HIDE);

			this.bu_delay = op.button_AUTO_HIDE_DELAY * 1000;
			this.bu_align = op.button_ALIGN.toLowerCase().split(' ');
			this.bu_margin = op.button_MARGIN;
			this.bu_round = checkBoolean(op.button_ROUND_CORNERS);

			this.touch_drag = checkBoolean(op.touch_DRAG);
			this.mouse_drag = checkBoolean(op.mouse_DRAG);
			this.mouse_wheel = checkBoolean(op.mouse_WHEEL);
			this.mouse_wheel_cur = checkBoolean(op.mouse_WHEEL_CURSOR_POS);
			this.mouse_dbl_click = checkBoolean(op.mouse_DOUBLE_CLICK);

			this.ani_smooth = Math.max(1, (op.animation_SMOOTHNESS + 1) / 1.45);

			this.bg_color = op.background_COLOR;
			this.bord_size = op.border_SIZE;
			this.bord_color = op.border_COLOR;
			this.bord_alpha = op.border_TRANSPARENCY / 100;

			this.container = op.container;
			this.image_url = op.image_url;
			this.image_width = op.image_original_width;
			this.image_height = op.image_original_height;

			this.responsive = checkBoolean(op.responsive);
			this.maintain_ratio = checkBoolean(op.responsive_maintain_ratio);
			this.w_max = op.max_WIDTH;
			this.h_max = op.max_HEIGHT;

			this.onLOAD = op.on_IMAGE_LOAD;
			this.onUPDATE = op.on_ZOOM_PAN_UPDATE;
			this.onZOOM_PAN = op.on_ZOOM_PAN_COMPLETE;
			this.onLANDMARK = op.on_LANDMARK_STATE_CHANGE;

			this.allowPinchZoom = op.allow_PINCH_ZOOM;

			/***********************************************************
   Variables for inner operation.	
   x, y, width, height and scale value of image
   ***********************************************************/
			this._x;
			this._y;
			this._w;
			this._h;
			this._sc = 0;

			this.rA = 1;
			this.rF = 1;
			this.rR = 1;
			this.iW = 0;
			this.iH = 0;
			this.tX = 0;
			this.tY = 0;
			this.oX = 0;
			this.oY = 0;
			this.fX = 0;
			this.fY = 0;
			this.dX = 0;
			this.dY = 0;
			this.cX = 0;
			this.cY = 0;

			this.transOffX = 0;
			this.transOffY = 0;
			this.focusOffX = 0;
			this.focusOffY = 0;
			this.offX = 0;
			this.offY = 0;

			/***********************************************************
   Flags that convey current states and events 
   ***********************************************************/
			this._playing = false;
			this._dragging = false;
			this._onfocus = false;
			this._moveCursor = false;
			this._wheel = false;
			this._recent = 'zoomOut';
			this._pinching = false;
			this._landmark = false;
			this._rA;
			this._centx;
			this._centy;
			this._onButton = false;
			this._onHitArea = false;
			this.cFlag = {
				_zi: false,
				_zo: false,
				_ml: false,
				_mr: false,
				_mu: false,
				_md: false,
				_rs: false,
				_nd: false
			};

			/***********************************************************
   Elements and arrays that references elements
   ***********************************************************/
			this.$holder;
			this.$buttons = op.button_HOLDER;
			this.$hitArea;
			this.$controls;
			this.$loc_cont;
			this.map_coordinates = [];
			this.locations = [];
			this.buttons = [];
			this.border = [];

			/***********************************************************
   miscellaneous
   ***********************************************************/
			this.buttons_total = 7;
			this.cButtId = 0;
			this.pan_speed;
			this.auto_timer;
			this.ani_timer;
			this.wheel_timer;
			this.ani_end;
			this.focusSpeed = this.reduction = 0.5;
			this.orig_style;
			this.mapAreas;
			this.icons;
			this.show_at_zoom;
			this.assetsLoaded = false;
			this.zStep = 0;
			this.sRed = 300;
			this.use3D = op.use_3D_Transform && supportsTrans3D;

			if (supportsTouch) {
				this.event_down = 'touchstart.sz';
				this.event_up = 'touchend.sz';
				this.event_move = 'touchmove.sz';
			} else {
				this.event_down = 'mousedown.sz';
				this.event_up = 'mouseup.sz';
				this.event_move = 'mousemove.sz';
			}

			//Case 1: Image specificed (possibly) through img tag:
			if (this.image_url == '') {
				this.$image = $elem;
				this.id = this.$image.attr('id');

				//Case 2: Image url specificed through parameter:
			} else {
				var img = new Image();
				if (this.image_width) {
					img.width = this.image_width;
				}
				if (this.image_height) {
					img.height = this.image_height;
				}
				img.src = this.image_url;
				this.$image = $(img).appendTo($elem);
			}

			//Prepare container div (Basically the element that masks image with overflow hidden)
			this.setContainer();

			//Get button icon image's url
			var testOb;
			if (!this.bu_icon) {
				var regx = /url\(["']?([^'")]+)['"]?\)/;
				testOb = $('<div class="smooth_zoom_icons"></div>');
				this.$holder.append(testOb);
				this.bu_icon = testOb.css('background-image').replace(regx, '$1');
				if (this.bu_icon == 'none') {
					this.bu_icon = 'zoom_assets/icons.png';
				}
				testOb.remove();
			}

			//Firefox feature checkup
			if (this.$image.css('-moz-transform') && prop_transform) {
				testOb = $('<div style="-moz-transform: translate(1px, 1px)"></div>');
				this.$holder.append(testOb);
				this.fixMoz = testOb.position().left !== 1;
				testOb.remove();
			} else {
				this.fixMoz = false;
			}

			//Preload icons and main image.	
			/*this.$image.hide();	
   this.imgList = [
   	{loaded: false, src: this.bu_icon || 'zoom_assets/icons.png'}, //Icon image
   	{loaded: false, src: this.image_url == ''? this.$image.attr('src') : this.image_url} // Main image
   ];
   
   $.each(this.imgList, function (i){
   	var _img = new Image();	
   	$(_img) .on('load', {id:i, self: self}, self.loadComplete)
   			.on('error', {id:i, self: self}, self.loadComplete); //Allow initiation even if image is not there :(
   	_img.src = self.imgList[i].src;	
   });*/

			// SKIP IMAGE PRELOADER
			self.assetsLoaded = true;
			if (self.onLOAD !== '') self.onLOAD();
			self.init();
		}

		Zoomer.prototype = {

			/*Preload the icon and main image
   *********************************************************************************************************************/
			loadComplete: function loadComplete(e) {
				var self = e.data.self,
				    complete = true;

				self.imgList[e.data.id].loaded = true;
				for (var j = 0; j < self.imgList.length; j++) {
					if (!self.imgList[j].loaded) {
						complete = false;
					}
				}
				if (complete) {
					self.assetsLoaded = true;
					if (self.onLOAD !== '') {
						self.onLOAD();
					}

					//Assets loaded, initiate plugin
					self.init();
				}
			},

			/*Initiate after assets loaded
   ***********************************************************************************************************************/
			init: function init() {
				var self = this,
				    $image = self.$image,
				    sW = self.sW,
				    sH = self.sH,
				    container = self.container,
				    cBW,
				    cBH,
				    pan_show = self.pan_show,
				    zoom_show = self.zoom_show,
				    $controls = self.$controls,
				    buttons = self.buttons,
				    cFlag = self.cFlag,
				    bu_align = self.bu_align,
				    bu_margin = self.bu_margin,
				    $holder = self.$holder,
				    $buttons = self.$buttons ? self.$buttons : self.$holder;

				//Store the default image properties so that it can be reverted back when plugin needs to be destroyed
				self.orig_style = self.getStyle();

				//IE 6 Image tool bar disabled
				$image.attr('galleryimg', 'no');

				if (!navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad)/)) {
					$image.removeAttr('width');
					$image.removeAttr('height');
				}

				//In case parent element's display property set to 'none', we need to first set them 'block', measure the width and height and then set them back to 'none'
				var temp = $image,
				    dispArray = [];
				for (var i = 0; i < 5; i++) {
					if (temp && temp[0].tagName !== 'BODY' && temp[0].tagName !== 'HTML') {
						if (temp.css('display') == 'none') {
							temp.css('display', 'block');
							dispArray.push(temp);
						}
						temp = temp.parent();
					} else {
						break;
					}
				}

				self.iW = $image.width();
				self.iH = $image.height();

				for (var i = 0; i < dispArray.length; i++) {
					dispArray[i].css('display', 'none');
				}

				//Initially the image needs to be resized to fit container. To do so, first measure the scaledown ratio	
				self.rF = self.rR = self.checkRatio(sW, sH, self.iW, self.iH, self.zoom_fit);

				//If NO Minimum zoom value set
				if (self.zoom_min == 0 || self.init_zoom != 0) {
					if (self.init_zoom != '') {
						self.rA = self._sc = self.init_zoom;
					} else {
						self.rA = self._sc = self.rF;
					}
					if (self.zoom_min != 0) {
						self.rF = self.zoom_min;
						if (self.reset_to_zmin) {
							self.rR = self.zoom_min;
						}
					}

					//If Minimum zoom value set
				} else {
					if (self.rF < self.zoom_min) {
						self.rF = self.zoom_min;
						if (self.reset_to_zmin) {
							self.rR = self.zoom_min;
						}
						self.rA = self._sc = self.zoom_min;
					} else {
						self.rA = self._sc = self.rR;
					}
				}

				//Width and Height to be applied to the image
				self._w = self._sc * self.iW;
				self._h = self._sc * self.iH;

				//Resize the image and position it centered inside the wrapper
				if (self.init_pos == '') {
					self._x = self.tX = (sW - self._w) / 2;
					self._y = self.tY = (sH - self._h) / 2;
				} else {
					self._x = self.tX = sW / 2 - parseInt(self.init_pos[0]) * self._sc;
					self._y = self.tY = sH / 2 - parseInt(self.init_pos[1]) * self._sc;
					self.oX = (self.tX - (sW - self._w) / 2) / (self._w / sW);
					self.oY = (self.tY - (sH - self._h) / 2) / (self._h / sH);
				}

				if ((!self.pan_limit || self._moveCursor || self.init_zoom != self.rF) && self.mouse_drag) {
					$image.css('cursor', 'move');
					self.$hitArea.css('cursor', 'move');
				}

				if (prop_transform) {
					self.$image.css(prop_origin, '0 0');
				}
				if (self.use3D) {
					$image.css({
						'-webkit-backface-visibility': 'hidden',
						'-webkit-perspective': 1000
					});
				}

				//Start displaying the image		
				$image.css({
					position: 'absolute',
					'z-index': 2,
					left: '0px',
					top: '0px',
					'-webkit-box-shadow': '1px 1px rgba(0,0,0,0)'
				}).hide().fadeIn(500, function () {
					$holder.css('background-image', 'none');
				});

				//Create Control buttons and events				
				var self = self,
				    bs = self.bu_size,
				    iSize = 50,
				    sDiff = 2,
				    bSpace = 3,
				    mSize = Math.ceil(self.bu_size / 4),
				    iconOff = bs < 16 ? 50 : 0,
				    bsDiff = bs - sDiff;

				//Show all buttons		
				if (pan_show) {
					if (zoom_show) {
						cBW = parseInt(bs + bs * 0.85 + bsDiff * 3 + bSpace * 2 + mSize * 2);
					} else {
						cBW = parseInt(bsDiff * 3 + bSpace * 2 + mSize * 2);
					}
					cBH = parseInt(bsDiff * 3 + bSpace * 2 + mSize * 2);

					//Show zoom buttons only		
				} else {
					if (zoom_show) {
						cBW = parseInt(bs + mSize * 2);
						cBH = parseInt(bs * 2 + mSize * 3);
						cBW = parseInt(cBW / 2) * 2;
						cBH = parseInt(cBH / 2) * 2;
					} else {
						cBW = 0;
						cBH = 0;
					}
				}

				var pOff = (iSize - bs) / 2,
				    resetCenterX = cBW - (bs - (pan_show ? sDiff : 0)) * 2 - mSize - bSpace,
				    resetCenterY = cBH / 2 - (bs - (pan_show ? sDiff : 0)) / 2;

				var hProp, vProp, hVal, vVal;
				//Align button set as per settings
				if (bu_align[0] == 'top') {
					vProp = 'top';
					vVal = bu_margin;
				} else if (bu_align[0] == 'center') {
					vProp = 'top';
					vVal = parseInt((sH - cBH) / 2);
				} else {
					vProp = 'bottom';
					vVal = bu_margin;
				}
				if (bu_align[1] == 'right') {
					hProp = 'right';
					hVal = bu_margin;
				} else if (bu_align[1] == 'center') {
					hProp = 'right';
					hVal = parseInt((sW - cBW) / 2);
				} else {
					hProp = 'left';
					hVal = bu_margin;
				}

				//Buttons Container		
				$controls = $('<div style="position: absolute; ' + hProp + ':' + hVal + 'px; ' + vProp + ': ' + vVal + 'px; width: ' + cBW + 'px; height: ' + cBH + 'px; z-index: 20;" class="noSel;">\
					<div class="noSel controlsBg" style="position: relative; width: 100%; height: 100%; z-index: 1;">\
					</div>\
				</div>');

				$buttons.append($controls);
				var $controlsBg = $controls.find('.controlsBg');

				//Make the corners rounded
				if (self.bu_round) {
					if (prop_radius) {
						$controlsBg.css(prop_radius, (iconOff > 0 ? 4 : 5) + 'px').css('background-color', self.bu_bg);
					} else {
						self.roundBG($controlsBg, 'cBg', cBW, cBH, iconOff > 0 ? 4 : 5, 375, self.bu_bg, self.bu_icon, 1, iconOff ? 50 : 0);
					}
				} else {
					$controlsBg.css('background-color', self.bu_bg);
				}

				$controlsBg.css('opacity', self.bu_bg_alpha);

				//Generating Button properties	(7 buttons)			
				buttons[0] = {
					_var: '_zi',
					l: mSize,
					t: pan_show ? (cBH - bs * 2 - bSpace * 2 + 2) / 2 : mSize,
					w: bs,
					h: bs,
					bx: -pOff,
					by: -pOff - iconOff
				};

				buttons[1] = {
					_var: '_zo',
					l: mSize,
					t: pan_show ? (cBH - bs * 2 - bSpace * 2 + 2) / 2 + bs + bSpace * 2 - 2 : cBH - bs - mSize,
					w: bs,
					h: bs,
					bx: -iSize - pOff,
					by: -pOff - iconOff
				};

				buttons[2] = {
					_var: self.pan_rev ? '_ml' : '_mr',
					l: resetCenterX - bsDiff - bSpace,
					t: resetCenterY,
					w: bsDiff,
					h: bsDiff,
					bx: -(sDiff / 2) - iSize * 2 - pOff,
					by: -(sDiff / 2) - pOff - iconOff
				};

				buttons[3] = {
					_var: self.pan_rev ? '_mr' : '_ml',
					l: resetCenterX + bsDiff + bSpace,
					t: resetCenterY,
					w: bsDiff,
					h: bsDiff,
					bx: -(sDiff / 2) - iSize * 3 - pOff,
					by: -(sDiff / 2) - pOff - iconOff
				};

				buttons[4] = {
					_var: self.pan_rev ? '_md' : '_mu',
					l: resetCenterX,
					t: resetCenterY + bsDiff + bSpace,
					w: bsDiff,
					h: bsDiff,
					bx: -(sDiff / 2) - iSize * 4 - pOff,
					by: -(sDiff / 2) - pOff - iconOff
				};

				buttons[5] = {
					_var: self.pan_rev ? '_mu' : '_md',
					l: resetCenterX,
					t: resetCenterY - bsDiff - bSpace,
					w: bsDiff,
					h: bsDiff,
					bx: -(sDiff / 2) - iSize * 5 - pOff,
					by: -(sDiff / 2) - pOff - iconOff
				};

				buttons[6] = {
					_var: '_rs',
					l: resetCenterX,
					t: resetCenterY,
					w: bsDiff,
					h: bsDiff,
					bx: -(sDiff / 2) - iSize * 6 - pOff,
					by: -(sDiff / 2) - pOff - iconOff
				};

				for (var i = 0; i < 7; i++) {
					buttons[i].$ob = $('<div style="position: absolute; display: ' + (i < 2 ? zoom_show ? 'block' : 'none' : pan_show ? 'block' : 'none') + '; left: ' + (buttons[i].l - 1) + 'px; top: ' + (buttons[i].t - 1) + 'px; width: ' + (buttons[i].w + 2) + 'px; height: ' + (buttons[i].h + 2) + 'px; z-index:' + (i + 1) + ';" class="noSel">\
						</div>').css('opacity', 0.7).on((supportsTouch ? '' : 'mouseover.sz mouseout.sz ') + self.event_down, {
						id: i

					}, function (e) {
						self._onfocus = false;
						var $this = $(this);

						//Button over 
						if (e.type == 'mouseover') {
							if ($this.css('opacity') > 0.5) {
								$this.css('opacity', 1);
							}

							//Button out 
						} else if (e.type == 'mouseout') {
							if ($this.css('opacity') > 0.5) {
								$this.css('opacity', 0.7);
							}

							//Button press/down
						} else if (e.type == 'mousedown' || e.type == 'touchstart') {
							self.cButtId = e.data.id;
							self._onButton = true;
							self._wheel = false;

							//If NOT already down..
							if ($this.css('opacity') > 0.5) {
								$this.css('opacity', 1);
								$holder.find('#' + buttons[self.cButtId]._var + 'norm').hide();
								$holder.find('#' + buttons[self.cButtId]._var + 'over').show();

								//CASE 1: If zoomIn pressed and single step zoom enabled
								if (self.cButtId <= 1 && self.zoom_single) {
									if (!cFlag[buttons[self.cButtId]._var]) {
										self.sRed = 300;
										cFlag[buttons[self.cButtId]._var] = true;
									}

									//CASE 2: If any button except RESET pressed
								} else if (self.cButtId < 6) {
									cFlag[buttons[self.cButtId]._var] = true;

									//CASE 3: RESET pressed							
								} else {
									cFlag._rs = true;
									self.rA = self.rR;
									if (self.reset_align[0] == 'top') {
										self.fY = self.sH / 2 * (self.rA / 2);
									} else if (self.reset_align[0] == 'bottom') {
										self.fY = -(self.sH / 2) * (self.rA / 2);
									} else {
										self.fY = 0;
									}
									if (self.reset_align[1] == 'left') {
										self.fX = self.sW / 2 * (self.rA / 2);
									} else if (self.reset_align[1] == 'right') {
										self.fX = -(self.sW / 2) * (self.rA / 2);
									} else {
										self.fX = 0;
									}
								}

								self.focusOffX = self.focusOffY = 0;
								self.changeOffset(true, true);
								if (!self._playing) {
									self.Animate();
								}
							}
							e.preventDefault();
							e.stopPropagation();
						}
					});

					//Make 2 BGs for Button Normal and Over state
					//Button BG normal
					var tpm = $('<div id="' + buttons[i]._var + 'norm" style="position: absolute; left: 1px; top: 1px; width: ' + buttons[i].w + 'px; height: ' + buttons[i].h + 'px; ' + (prop_radius || !self.bu_round ? 'background:' + self.bu_color : '') + '">\
					</div>');

					//Button BG hover
					var tpmo = $('<div id="' + buttons[i]._var + 'over" style="position: absolute; left: 0px; top: 0px; width: ' + (buttons[i].w + 2) + 'px; height: ' + (buttons[i].h + 2) + 'px; display: none; ' + (prop_radius || !self.bu_round ? 'background:' + self.bu_color : '') + '">\
					</div>');

					//Add the button icons
					var cont = $('<div id="' + buttons[i]._var + '_icon" style="position: absolute; left: 1px; top: 1px; width: ' + buttons[i].w + 'px; height: ' + buttons[i].h + 'px; background: transparent url(' + self.bu_icon + ') ' + buttons[i].bx + 'px ' + buttons[i].by + 'px no-repeat;" >\
					</div>');

					buttons[i].$ob.append(tpm, tpmo, cont);
					$controls.append(buttons[i].$ob);

					//Apply corner radius
					if (self.bu_round) {
						if (prop_radius) {
							tpm.css(prop_radius, '2px');
							tpmo.css(prop_radius, '2px');
						} else {
							self.roundBG(tpm, buttons[i]._var + 'norm', buttons[i].w, buttons[i].h, 2, 425, self.bu_color, self.bu_icon, i + 1, iconOff ? 50 : 0);
							self.roundBG(tpmo, buttons[i]._var + 'over', buttons[i].w + 2, buttons[i].h + 2, 2, 425, self.bu_color, self.bu_icon, i + 1, iconOff ? 50 : 0);
						}
					}
				}

				//Add Events for mouse drag / touch swipe action
				$(document).on(self.event_up + self.id, { self: self }, self.mouseUp);

				if (self.mouse_drag && !supportsTouch || self.touch_drag && supportsTouch) {
					self.$holder.on(self.event_down, { self: self }, self.mouseDown);
					if (supportsTouch) {
						$(document).on(self.event_move + self.id, { self: self }, self.mouseDrag);
					}
				}

				//Add Double click / Double tap zoom
				if (self.mouse_dbl_click) {
					var dClickedX,
					    dClickedY,
					    dbl_click_dir = 1;

					self.$holder.on('dblclick.sz', function (e) {
						self.focusOffX = e.pageX - $holder.offset().left - self.sW / 2;
						self.focusOffY = e.pageY - $holder.offset().top - self.sH / 2;
						self.changeOffset(true, true);
						self._wheel = false;

						if (!window.doubleClick || window.doubleClick < 1) {

							if (self.rA < self.zoom_max && dbl_click_dir == -1 && dClickedX != self.focusOffX && dClickedY != self.focusOffY) {
								dbl_click_dir = 1;
							}

							dClickedX = self.focusOffX;
							dClickedY = self.focusOffY;

							if (self.rA >= self.zoom_max && dbl_click_dir == 1) {
								dbl_click_dir = -1;
							}
							if (self.rA <= self.rF && dbl_click_dir == -1) {
								dbl_click_dir = 1;
							}
							if (dbl_click_dir > 0) {
								self.rA *= 2;
								self.rA = self.rA > self.zoom_max ? self.zoom_max : self.rA;
								cFlag._zi = true;
								clearTimeout(self.ani_timer);
								self._playing = true;
								self.Animate();
								cFlag._zi = false;
							} else {
								self.rA /= 2;
								self.rA = self.rA < self.rF ? self.rF : self.rA;
								cFlag._zo = true;
								clearTimeout(self.ani_timer);
								self._playing = true;
								self.Animate();
								cFlag._zo = false;
							}
							e.preventDefault();
							e.stopPropagation();
						}
					});
				}

				//Add mouse wheel event if enabled
				if (self.mouse_wheel) {
					$holder.parent().on('mousewheel.sz', { self: this }, self.mouseWheel);
				}

				//Auto Hide the control buttons if enabled
				if (self.bu_auto) {
					$holder.on('mouseleave.sz', { self: this }, self.autoHide);
				}

				//Prevent Controls Bg from start dragging image
				$controls.on(self.event_down, function (e) {
					e.preventDefault();
					e.stopPropagation();
				});

				//Prevent Controls Bg from double click zoom
				if (self.mouse_dbl_click) {
					$controls.on('dblclick.sz', function (e) {
						e.preventDefault();
						e.stopPropagation();
					});
				}

				//Prevent text selection for smoother dragging and button focus
				$('.noSel').each(function () {
					this.onselectstart = function () {
						return false;
					};
				});

				self.$holder = $holder;
				self.$controls = $controls;
				self.sW = sW;
				self.sH = sH;
				self.cBW = cBW;
				self.cBH = cBH;

				//Apply initial transformation
				self.Animate();
			},

			/*Prepare the container (holder) element and get landmarks if available
   ***********************************************************************************************************************/
			setContainer: function setContainer() {
				var self = this,
				    $image = self.$image,
				    bord_size = self.bord_size,
				    border = self.border,
				    $holder = self.$holder;

				//Wrap a container for image or get the container if specified through options:
				if (self.container == '' && self.image_url == '') {
					$holder = self.$image.wrap('<div class="noSel smooth_zoom_preloader">\
					</div>').parent();
				} else {
					if (self.image_url == '') {
						$holder = $('#' + self.container);
					} else {
						$holder = self.$elem;
					}
					$holder.addClass('noSel smooth_zoom_preloader');
					self.locations = [];
					self.$loc_cont = $holder.find('.landmarks');
					if (self.$loc_cont[0]) {
						var locs = self.$loc_cont.children('.item');
						self.loc_clone = self.$loc_cont.clone();
						self.show_at_zoom = parseInt(self.$loc_cont.data('show-at-zoom'), 10) / 100;
						self.allow_scale = checkBoolean(self.$loc_cont.data('allow-scale'));
						self.allow_drag = checkBoolean(self.$loc_cont.data('allow-drag'));
						locs.each(function () {
							self.setLocation($(this));
						});
					}
				}

				$holder.css({
					'position': 'relative',
					'overflow': 'hidden',
					'text-align': 'left',
					'-moz-user-select': 'none',
					'-khtml-user-select': 'none',
					'-webkit-user-select': 'none',
					'user-select': 'none',
					'-webkit-touch-callout': 'none',
					'-webkit-tap-highlight-color': 'rgba(255, 255, 255, 0)',
					'background-color': self.bg_color,
					'background-position': 'center center',
					'background-repeat': 'no-repeat'
				});

				self.$hitArea = $('<div style="position: absolute; z-index: 1; top: 0px; left: 0px; width: 100%; height: 100%;" ></div>').appendTo($holder);

				self.getContainerSize(self.sW, self.sH, $holder, self.w_max, self.h_max);

				if (self.responsive) {
					$(window).on('orientationchange.sz' + self.id + ' resize.sz' + self.id, { self: self }, self.resize);
				}
				var sW = self.sW;
				var sH = self.sH;

				//Add Image container properties			
				$holder.css({
					'width': sW,
					'height': sH
				});

				//Add border if needed
				if (bord_size > 0) {
					border[0] = $('<div style="position: absolute;	width: ' + bord_size + 'px; height: ' + sH + 'px;	top: 0px; left: 0px; z-index: 3; background-color: ' + self.bord_color + ';"></div>').css('opacity', self.bord_alpha);
					border[1] = $('<div style="position: absolute;	width: ' + bord_size + 'px; height: ' + sH + 'px;	top: 0px; left: ' + (sW - bord_size) + 'px; z-index: 4; background-color: ' + self.bord_color + ';"></div>').css('opacity', self.bord_alpha);
					border[2] = $('<div style="position: absolute;	width: ' + (sW - bord_size * 2) + 'px; height: ' + bord_size + 'px; top: 0px; left: ' + bord_size + 'px; z-index: 5; background-color: ' + self.bord_color + '; line-height: 1px;"></div>').css('opacity', self.bord_alpha);
					border[3] = $('<div style="position: absolute;	width: ' + (sW - bord_size * 2) + 'px; height: ' + bord_size + 'px; top: ' + (sH - bord_size) + 'px; left: ' + bord_size + 'px; z-index: 6; background-color: ' + self.bord_color + '; line-height: 1px;"></div>').css('opacity', self.bord_alpha);
					$holder.append(border[0], border[1], border[2], border[3]);
				}

				//Get Image maps if exists
				if ($image.attr('usemap') != undefined) {
					self.mapAreas = $("map[name='" + $image.attr('usemap').split('#').join('') + "']").children('area');
					self.mapAreas.each(function (i) {
						var area = $(this);
						area.css('cursor', 'pointer');
						if (self.mouse_drag) {
							area.on(self.event_down, { self: self }, self.mouseDown);
						}
						if (self.mouse_wheel) {
							area.on('mousewheel.sz', { self: self }, self.mouseWheel);
						}
						self.map_coordinates.push(area.attr('coords').split(','));
					});
				}

				self.$holder = $holder;
				self.sW = sW;
				self.sH = sH;
			},

			getContainerSize: function getContainerSize(sW, sH, $holder, w_max, h_max) {
				if (sW === '' || sW === 0) {
					if (this.image_url == '') {
						sW = Math.max($holder.parent().width(), 100);
					} else {
						sW = Math.max($holder.width(), 100);
					}
				} else if (!isNaN(sW) || String(sW).indexOf('px') > -1) {
					sW = this.oW = parseInt(sW);
					if (this.responsive) {
						sW = Math.min($holder.parent().width(), sW);
					}
				} else if (String(sW).indexOf('%') > -1) {
					sW = $holder.parent().width() * (sW.split('%')[0] / 100);
				} else {
					sW = 100;
				}
				if (w_max !== 0 && w_max !== '') {
					sW = Math.min(sW, w_max);
				}
				if (sH === '' || sH === 0) {
					if (this.image_url == '') {
						sH = Math.max($holder.parent().height(), 100);
					} else {
						sH = Math.max($holder.height(), 100);
					}
				} else if (!isNaN(sH) || String(sH).indexOf('px') > -1) {
					sH = this.oH = parseInt(sH);
				} else if (String(sH).indexOf('%') > -1) {
					sH = $holder.parent().height() * (sH.split('%')[0] / 100);
				} else {
					sH = 100;
				}
				if (h_max !== 0 && h_max !== '') {
					sH = Math.min(sH, h_max);
				}

				if (this.oW && sW !== this.oW) {
					if (this.oH && this.maintain_ratio) {
						sH = sW / (this.oW / this.oH);
					}
				}

				this.sW = sW;
				this.sH = sH;
			},

			/*Each landmark / location / lable initiated here
   ***********************************************************************************************************************/
			setLocation: function setLocation(lc) {
				var self = this,
				    ob = lc,
				    w2,
				    h2,
				    pos,
				    sc;

				if (prop_origin) {
					ob.css(prop_origin, '0 0');
				}

				ob.css({
					'display': 'block',
					'z-index': 2
				});
				if (self.use3D) {
					ob.css({
						'-webkit-backface-visibility': 'hidden',
						'-webkit-perspective': 1000
					});
				}

				w2 = ob.outerWidth() / 2;
				h2 = ob.outerHeight() / 2;
				pos = ob.data('position').split(',');
				sc = ob.data('allow-scale');
				if (sc == undefined) {
					sc = self.allow_scale;
				} else {
					sc = checkBoolean(sc);
				}

				if (ob.hasClass('mark')) {
					var imgw = ob.find('img').css('vertical-align', 'bottom').width();
					$(ob.children()[0]).css({
						'position': 'absolute',
						'left': -ob.width() / 2,
						'bottom': parseInt(ob.css('padding-bottom')) * 2
					});
					var txt = ob.find('.text');
					self.locations.push({
						ob: ob,
						x: parseInt(pos[0]),
						y: parseInt(pos[1]),
						w2: w2,
						h2: h2,
						w2pad: w2 + (txt[0] ? parseInt(txt.css('padding-left')) : 0),
						vis: false,
						lab: false,
						lpx: '0',
						lpy: '0',
						showAt: isNaN(ob.data('show-at-zoom')) ? self.show_at_zoom : parseInt(ob.data('show-at-zoom'), 10) / 100,
						scale: sc
					});
				} else if (ob.hasClass('lable')) {
					var bg = ob.data('bg-color'),
					    opacity = ob.data('bg-opacity'),
					    cont = $(ob.eq(0).children()[0]).css({
						'position': 'absolute',
						'z-index': 2,
						left: -w2,
						top: -h2
					});

					self.locations.push({
						ob: ob,
						x: parseInt(pos[0]),
						y: parseInt(pos[1]),
						w2: w2,
						h2: h2,
						w2pad: w2,
						vis: false,
						lab: true,
						lpx: '0',
						lpy: '0',
						showAt: isNaN(ob.data('show-at-zoom')) ? self.show_at_zoom : parseInt(ob.data('show-at-zoom'), 10) / 100,
						scale: sc
					});

					if (bg !== '') {
						if (!bg) {
							bg = '#000000';
							opacity = 0.7;
						}
						var bgob = $('<div style="position: absolute; left: ' + -w2 + 'px; top: ' + -h2 + 'px; width: ' + (w2 - parseInt(cont.css('padding-left'))) * 2 + 'px; height:' + (h2 - parseInt(cont.css('padding-top'))) * 2 + 'px; background-color: ' + bg + ';"></div>').appendTo(ob);
						if (opacity) {
							bgob.css('opacity', opacity);
						}
					}
				}
				ob.hide();
				if (prop_transform) {
					ob.css('opacity', 0);
				}
				if (!self.allow_drag) {
					ob.on(self.event_down, function (e) {
						//e.preventDefault();
						e.stopPropagation();
					});
				}
			},

			/*Storing the original style of image (needed only when destroying)
   ***********************************************************************************************************************/
			getStyle: function getStyle() {
				var el = this.$image;
				return {
					prop_origin: [prop_origin, prop_origin !== false && prop_origin !== undefined ? el.css(prop_origin) : null],
					prop_transform: [prop_transform, prop_transform !== false && prop_transform !== undefined ? el.css(prop_transform) : null],
					'position': ['position', el.css('position')],
					'z-index': ['z-index', el.css('z-index')],
					'cursor': ['cursor', el.css('cursor')],
					'left': ['left', el.css('left')],
					'top': ['top', el.css('top')],
					'width': ['width', el.css('width')],
					'height': ['height', el.css('height')]
				};
			},

			/*Find the scale ratios
   ***********************************************************************************************************************/
			checkRatio: function checkRatio(sW, sH, iW, iH, zoom_fit) {
				var rF;
				if (iW == sW && iH == sH) {
					rF = 1;
				} else if (iW < sW && iH < sH) {
					rF = sW / iW;
					if (zoom_fit) {
						if (rF * iH > sH) {
							rF = sH / iH;
						}
					} else {
						if (rF * iH < sH) {
							rF = sH / iH;
						}
						if (sW / iW !== sH / iH && this.mouse_drag) {
							this._moveCursor = true;
							this.$image.css('cursor', 'move');
							this.$hitArea.css('cursor', 'move');
						}
					}
				} else {

					rF = sW / iW;
					if (zoom_fit) {
						if (rF * iH > sH) {
							rF = sH / iH;
						}
						if (rF < this.init_zoom && this.mouse_drag) {
							this._moveCursor = true;
							this.$image.css('cursor', 'move');
							this.$hitArea.css('cursor', 'move');
						}
					} else {
						if (rF * iH < sH) {
							rF = sH / iH;
						}
						if (sW / iW !== sH / iH && this.mouse_drag) {
							this._moveCursor = true;
							this.$image.css('cursor', 'move');
							this.$hitArea.css('cursor', 'move');
						}
					}
				}
				return rF;
			},

			/*Returns distance between 2 points (used for touch gesture)
   ***********************************************************************************************************************/
			getDistance: function getDistance(x1, y1, x2, y2) {
				return Math.sqrt(Math.abs((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1)));
			},

			/*Image Events for Dragging and Mouse Wheel
   ***********************************************************************************************************************/
			mouseDown: function mouseDown(e) {
				var self = e.data.self;
				self._onfocus = self._dragging = false;
				if (self.cFlag._nd) {
					if (self.fixMoz) {
						self.correctTransValue();
					}
					self.samePointRelease = false;
					if (e.type == 'mousedown') {
						self.stX = e.pageX;
						self.stY = e.pageY;
						self.offX = e.pageX - self.$holder.offset().left - self.$image.position().left;
						self.offY = e.pageY - self.$holder.offset().top - self.$image.position().top;
						$(document).on(self.event_move + self.id, { self: self }, self.mouseDrag);
					} else {
						var te = e.originalEvent;
						if (te.targetTouches.length > 1) {
							self._pinching = true;
							self._rA = self.rA;
							self.dStart = self.getDistance(te.touches[0].pageX, te.touches[0].pageY, te.touches[1].pageX, te.touches[1].pageY);
						} else {
							self.offX = te.touches[0].pageX - self.$holder.offset().left - self.$image.position().left;
							self.offY = te.touches[0].pageY - self.$holder.offset().top - self.$image.position().top;
							self.setDraggedPos(te.touches[0].pageX - self.$holder.offset().left - self.offX, te.touches[0].pageY - self.$holder.offset().top - self.offY, self._sc);
							self._recent = 'drag';
							self._dragging = true;
						}
					}
					self._onHitArea = true;
				}
				if (e.type == 'mousedown') {
					e.preventDefault();
				}
			},

			/*Mouse Drag / Touch swipe operations handled here
   ***********************************************************************************************************************/
			mouseDrag: function mouseDrag(e) {
				var self = e.data.self;

				//Mouse
				if (e.type == 'mousemove') {
					self.setDraggedPos(e.pageX - self.$holder.offset().left - self.offX, e.pageY - self.$holder.offset().top - self.offY, self._sc);
					self._recent = 'drag';
					self._dragging = true;
					if (!self._playing) {
						self.Animate();
					}
					return false;

					//Touch				
				} else {
					if (self._dragging || self._pinching) {
						e.preventDefault();
					}
					if (self._onHitArea) {
						var touches = e.originalEvent.touches;
						if (self._pinching || touches.length > 1) {
							if (self.allowPinchZoom) {
								if (!self._pinching) {
									self._pinching = true;
									self._rA = self.rA;
									if (touches.length > 1) {
										self.dStart = self.getDistance(touches[0].pageX, touches[0].pageY, touches[1].pageX, touches[1].pageY);
									}
								}
								if (touches.length > 1) {
									self._centx = (touches[0].pageX + touches[1].pageX) / 2;
									self._centy = (touches[0].pageY + touches[1].pageY) / 2;
									self.focusOffX = self._centx - self.$holder.offset().left - self.sW / 2;
									self.focusOffY = self._centy - self.$holder.offset().top - self.sH / 2;
									self.changeOffset(true, true);
									self._wheel = true;
									self._dragging = false;
									if (self.zoom_single) {
										self.sRed = 300;
									} else {
										self.dEnd = self.getDistance(touches[0].pageX, touches[0].pageY, touches[1].pageX, touches[1].pageY);
										self.rA = self._rA * (self.dEnd / self.dStart);
										self.rA = self.rA > self.zoom_max ? self.zoom_max : self.rA;
										self.rA = self.rA < self.rF ? self.rF : self.rA;
									}
									if (self._sc < self.rA) {
										self.cFlag._zo = false;
										self.cFlag._zi = true;
									} else {
										self.cFlag._zi = false;
										self.cFlag._zo = true;
									}
									if (!self._playing) {
										self.Animate();
									}
								}
							}
						} else if (self._dragging && touches.length < 2) {
							self.setDraggedPos(touches[0].pageX - self.$holder.offset().left - self.offX, touches[0].pageY - self.$holder.offset().top - self.offY, self._sc);
							self._recent = 'drag';
							if (!self._playing) {
								self.Animate();
							}
						}
					}
				}
			},

			/*Global Mouse Up / Touch End
   ***********************************************************************************************************************/
			mouseUp: function mouseUp(e) {
				var self = e.data.self;

				//If one of the buttons released
				if (self._onButton) {
					self.$holder.find('#' + self.buttons[self.cButtId]._var + 'norm').show();
					self.$holder.find('#' + self.buttons[self.cButtId]._var + 'over').hide();
					if (self.cButtId !== 6) {
						self.cFlag[self.buttons[self.cButtId]._var] = false;
					}
					if (e.type == 'touchend' && self.buttons[self.cButtId].$ob.css('opacity') > 0.5) {
						self.buttons[self.cButtId].$ob.css('opacity', 0.7);
					}
					self._onButton = false;
					e.stopPropagation();
					return false;

					//If the mouse drag or touch swipe completed
				} else if (self._onHitArea) {
					if (self.mouse_drag || self.touch_drag) {
						//Mouse					
						if (e.type == 'mouseup') {
							$(document).off(self.event_move + self.id);
							if (self.stX == e.pageX && self.stY == e.pageY) {
								self.samePointRelease = true;
							}
							self._recent = 'drag';
							self._dragging = false;
							if (!self._playing) {
								self.Animate();
							}
							self._onHitArea = false;

							//Touch
						} else {
							e.preventDefault();
							self._dragging = false;
							if (self._pinching) {
								self._pinching = false;
								self._wheel = false;
								self.cFlag._nd = true;
								self.cFlag._zi = false;
								self.cFlag._zo = false;
							} else {
								self._recent = 'drag';
								if (!self._playing) {
									self.Animate();
								}
							}
							self._onHitArea = false;
						}
					}
				}
			},

			/*Mouse wheel zoom in-out
   ***********************************************************************************************************************/
			mouseWheel: function mouseWheel(e, delta) {
				if (e.deltaY && e.deltaY % 1 !== 0) {
					e.preventDefault();
				}
				var self = e.data.self;
				self._onfocus = self._dragging = false;
				if (self.mouse_wheel_cur) {
					self.focusOffX = e.pageX - self.$holder.offset().left - self.sW / 2;
					self.focusOffY = e.pageY - self.$holder.offset().top - self.sH / 2;
					self.changeOffset(true, true);
				}

				self._dragging = false;
				if (delta > 0) {
					if (self.rA != self.zoom_max) {
						if (self.zoom_single) {
							if (!self._wheel) {
								self.sRed = 300;
							}
						} else {
							self.rA *= delta < 1 ? 1 + 0.3 * delta : 1.3;
							self.rA = self.rA > self.zoom_max ? self.zoom_max : self.rA;
						}
						self._wheel = true;
						self.cFlag._zi = true;
						clearTimeout(self.ani_timer);
						self._playing = true;
						self.Animate();
						self.cFlag._zi = false;
					}
				} else {
					if (self.rA != self.rF) {
						if (self.zoom_single) {
							if (!self._wheel) {
								self.sRed = 300;
							}
						} else {
							self.rA /= delta > -1 ? 1 + 0.3 * -delta : 1.3;
							self.rA = self.rA < self.rF ? self.rF : self.rA;
						}
						self._wheel = true;
						self.cFlag._zo = true;
						clearTimeout(self.ani_timer);
						self._playing = true;
						self.Animate();
						self.cFlag._zo = false;
					}
				}

				self.$map.addClass('map--wheel');
				clearTimeout(self.wheel_timer);
				self.wheel_timer = setTimeout(function () {
					self.$map.removeClass('map--wheel');
				}, 200);

				return false;
			},

			/*Control buttons Auto hide
   ***********************************************************************************************************************/
			autoHide: function autoHide(e) {
				var self = e.data.self;

				clearTimeout(self.auto_timer);
				self.auto_timer = setTimeout(function () {
					self.$controls.fadeOut(600);
				}, self.bu_delay);

				self.$holder.on('mouseenter.sz', function (e) {
					clearTimeout(self.auto_timer);
					self.$controls.fadeIn(300);
				});
			},

			/*Mozilla works differently than others when getting translated positions. So this correction needed
   ***********************************************************************************************************************/
			correctTransValue: function correctTransValue() {
				var v = this.$image.css('-moz-transform').toString().replace(')', '').split(',');
				this.transOffX = parseInt(v[4]);
				this.transOffY = parseInt(v[5]);
			},

			/*Make sure the dragged position obeying limits
   ***********************************************************************************************************************/
			setDraggedPos: function setDraggedPos(xp, yp, s, resize) {
				var self = this;

				if (xp !== '') {
					self.dX = xp + self.transOffX;
					if (self.pan_limit) {
						self.dX = self.dX + s * self.iW < self.sW ? self.sW - s * self.iW : self.dX;
						self.dX = self.dX > 0 ? 0 : self.dX;
						if (s * self.iW < self.sW) {
							self.dX = (self.sW - s * self.iW) / 2;
						}
					} else {
						self.dX = self.dX + s * self.iW < self.sW / 2 ? self.sW / 2 - s * self.iW : self.dX;
						self.dX = self.dX > self.sW / 2 ? self.sW / 2 : self.dX;
					}
				}
				if (yp !== '') {
					self.dY = yp + self.transOffY;
					if (self.pan_limit) {
						self.dY = self.dY + s * self.iH < self.sH ? self.sH - s * self.iH : self.dY;
						self.dY = self.dY > 0 ? 0 : self.dY;
						if (s * self.iH < self.sH) {
							self.dY = (self.sH - s * self.iH) / 2;
						}
					} else {
						self.dY = self.dY + s * self.iH < self.sH / 2 ? self.sH / 2 - s * self.iH : self.dY;
						self.dY = self.dY > self.sH / 2 ? self.sH / 2 : self.dY;
					}
				}
				/*if(!resize){
    	//console.log(self.x_diff+' === '+xp);
    	self.x_diff = xp;
    	self.y_diff = yp;
    	self.img_w = self.$image.outerWidth();
    	self.img_h = self.$image.outerHeight();
    }*/
			},

			/*Called to animate image transformation whenever the navigation events occur
   ***********************************************************************************************************************/
			Animate: function Animate() {

				var self = this;
				var pixTol = 0.5;

				self.cFlag._nd = true;
				self.ani_end = false;

				//Zoom In
				if (self.cFlag._zi) {
					if (!self._wheel && !self.zoom_single) {
						self.rA *= self.zoom_speed;
					}
					if (self.rA > self.zoom_max) {
						self.rA = self.zoom_max;
					}
					self.cFlag._nd = false;
					self.cFlag._rs = false;
					self._recent = 'zoomIn';
					self._onfocus = self._dragging = false;
				}

				//Zoom Out
				if (self.cFlag._zo) {
					if (!self._wheel && !self.zoom_single) {
						self.rA /= self.zoom_speed;
					}
					if (self.zoom_min != 0) {
						if (self.rA < self.zoom_min) {
							self.rA = self.zoom_min;
						}
					} else {
						if (self.rA < self.rF) {
							self.rA = self.rF;
						}
					}

					self.cFlag._nd = false;
					self.cFlag._rs = false;
					self._recent = 'zoomOut';
					self._onfocus = self._dragging = false;
				}

				//Zoom In or Out - Single Step
				if (self.zoom_single && !self.cFlag._rs) {
					if (self._recent == 'zoomIn') {
						self.sRed += (10 - self.sRed) / 6;
						self.rA += (self.zoom_max - self.rA) / (1 / (self.pan_speed_o + 1) * self.sRed + 1);
					} else if (self._recent == 'zoomOut') {
						self.sRed += (3 - self.sRed) / 3;
						self.rA += (self.rF - self.rA) / ((1 / self.pan_speed_o + 1) * self.sRed + 1);
					}
				}

				//Pan speed needs to adjust according to application dimension and zoom level
				self.pan_speed = (Math.max(1, 1 + (self.sW + self.sH) / 500) + self.pan_speed_o * self.pan_speed_o / 4) / Math.max(1, self.rA / 2);

				//Move Left
				if (self.cFlag._ml) {
					self.oX -= self.pan_speed;
					self.cFlag._nd = false;
					self.cFlag._rs = false;
					self._recent = 'left';
					self._onfocus = self._dragging = false;
				}

				//Move Right
				if (self.cFlag._mr) {
					self.oX += self.pan_speed;
					self.cFlag._nd = false;
					self.cFlag._rs = false;
					self._recent = 'right';
					self._onfocus = self._dragging = false;
				}

				//Move Up
				if (self.cFlag._mu) {
					self.oY -= self.pan_speed;
					self.cFlag._nd = false;
					self.cFlag._rs = false;
					self._recent = 'up';
					self._onfocus = self._dragging = false;
				}

				//Move Down
				if (self.cFlag._md) {
					self.oY += self.pan_speed;
					self.cFlag._nd = false;
					self.cFlag._rs = false;
					self._recent = 'down';
					self._onfocus = self._dragging = false;
				}

				//Reset
				if (self.cFlag._rs) {
					self.oX += (self.fX - self.oX) / 8;
					self.oY += (self.fY - self.oY) / 8;
					self.cFlag._nd = false;
					self._recent = 'reset';
					self._onfocus = self._dragging = false;
				}

				//Find scale value, width and height
				//Case 1: Single Step Zoom
				if (self.zoom_single && self._recent !== 'reset') {
					if (self._onfocus) {
						self._sc += (self.rA - self._sc) / self.reduction;
					} else {
						self._sc = self.rA;
					}

					//Case 2: Normal Zoom
				} else {
					self._sc += (self.rA - self._sc) / (self.ani_smooth / (self._onfocus ? self.reduction : 1));
				}

				self._w = self._sc * self.iW;
				self._h = self._sc * self.iH;

				//Dragging
				if (self._dragging) {
					self.tX = self.dX;
					self.tY = self.dY;
					self.changeOffset(true, true);
				}

				//Check if Zoom In completed
				if (self._recent == 'zoomIn') {
					if (self._w > self.rA * self.iW - pixTol && !self.zoom_single) {
						if (self.cFlag._nd) {
							self.ani_end = true;
						}
						self._sc = self.rA;
					} else if (self._w > self.zoom_max * self.iW - pixTol && self.zoom_single) {
						if (self.cFlag._nd) {
							self.ani_end = true;
						}
						self._sc = self.rA = self.zoom_max;
					}
					if (self.ani_end) {
						self._w = self._sc * self.iW;
						self._h = self._sc * self.iH;
					}

					//Check if Zoom Out completed
				} else if (self._recent == 'zoomOut') {
					if (self._w < self.rA * self.iW + pixTol && !self.zoom_single) {
						if (self.cFlag._nd) {
							self.ani_end = true;
						}
						self._sc = self.rA;
					} else if (self._w < self.rF * self.iW + pixTol && self.zoom_single) {
						if (self.cFlag._nd) {
							self.ani_end = true;
						}
						self._sc = self.rA = self.rF;
					}
					if (self.ani_end) {
						self._w = self._sc * self.iW;
						self._h = self._sc * self.iH;
					}
				}

				//Move image according to boundary limits
				self.limitX = (self._w - self.sW) / (self._w / self.sW) / 2;
				self.limitY = (self._h - self.sH) / (self._h / self.sH) / 2;

				if (!self._dragging) {
					if (self.pan_limit) {
						if (self.oX < -self.limitX - self.focusOffX) {
							self.oX = -self.limitX - self.focusOffX;
						}
						if (self.oX > self.limitX - self.focusOffX) {
							self.oX = self.limitX - self.focusOffX;
						}
						if (self._w < self.sW) {
							self.tX = (self.sW - self._w) / 2;
							self.changeOffset(true, false);
						}
						if (self.oY < -self.limitY - self.focusOffY) {
							self.oY = -self.limitY - self.focusOffY;
						}
						if (self.oY > self.limitY - self.focusOffY) {
							self.oY = self.limitY - self.focusOffY;
						}
						if (self._h < self.sH) {
							self.tY = (self.sH - self._h) / 2;
							self.changeOffset(false, true);
						}
					} else {
						if (self.oX < -self.limitX - self.focusOffX / self._w * self.sW - self.sW / 2 / (self._w / self.sW)) {
							self.oX = -self.limitX - self.focusOffX / self._w * self.sW - self.sW / 2 / (self._w / self.sW);
						}

						if (self.oX > self.limitX - self.focusOffX / self._w * self.sW + self.sW / 2 / (self._w / self.sW)) {
							self.oX = self.limitX - self.focusOffX / self._w * self.sW + self.sW / 2 / (self._w / self.sW);
						}

						if (self.oY < -self.limitY - self.focusOffY / self._h * self.sH - self.sH / (self._h / self.sH * 2)) {
							self.oY = -self.limitY - self.focusOffY / self._h * self.sH - self.sH / (self._h / self.sH * 2);
						}

						if (self.oY > self.limitY - self.focusOffY / self._h * self.sH + self.sH / (self._h / self.sH * 2)) {
							self.oY = self.limitY - self.focusOffY / self._h * self.sH + self.sH / (self._h / self.sH * 2);
						}
					}
				}
				if (!self._dragging && self._recent != 'drag') {
					self.tX = (self.sW - self._w) / 2 + self.focusOffX + self.oX * (self._w / self.sW);
					self.tY = (self.sH - self._h) / 2 + self.focusOffY + self.oY * (self._h / self.sH);
					if (self.ani_smooth === 1) {
						self.cFlag._nd = true;
						self.ani_end = true;
					}
				}
				if (self._recent == 'zoomIn' || self._recent == 'zoomOut' || self.cFlag._rs) {
					self._x = self.tX;
					self._y = self.tY;
				} else {
					self._x += (self.tX - self._x) / (self.ani_smooth / (self._onfocus ? self.reduction : 1));
					self._y += (self.tY - self._y) / (self.ani_smooth / (self._onfocus ? self.reduction : 1));
				}

				//Check if Left movement completed
				if (self._recent == 'left') {
					if (self._x < self.tX + pixTol || self.ani_smooth === 1) {
						self.cFlag._nd ? self.ani_end = true : '';
						self._recent = '';
						self._x = self.tX;
					}

					//Check if Right  movement completed
				} else if (self._recent == 'right') {
					if (self._x > self.tX - pixTol || self.ani_smooth === 1) {
						self.cFlag._nd ? self.ani_end = true : '';
						self._recent = '';
						self._x = self.tX;
					}

					//Check if Up movement completed
				} else if (self._recent == 'up') {
					if (self._y < self.tY + pixTol || self.ani_smooth === 1) {
						self.cFlag._nd ? self.ani_end = true : '';
						self._recent = '';
						self._y = self.tY;
					}

					//Check if Down movement completed
				} else if (self._recent == 'down') {
					if (self._y > self.tY - pixTol || self.ani_smooth === 1) {
						self.cFlag._nd ? self.ani_end = true : '';
						self._recent = '';
						self._y = self.tY;
					}

					//Check if Dragging completed
				} else if (self._recent == 'drag') {
					if (self._x + pixTol >= self.tX && self._x - pixTol <= self.tX && self._y + pixTol >= self.tY && self._y - pixTol <= self.tY || self.ani_smooth === 1) {
						if (self._onfocus) {
							self._dragging = false;
						}
						self.cFlag._nd ? self.ani_end = true : '';
						self._recent = '';
						self._x = self.tX;
						self._y = self.tY;
					}
				}

				//Check if Reset completed
				if (self.cFlag._rs && self._w + pixTol >= self.rA * self.iW && self._w - pixTol <= self.rA * self.iW && self.oX <= self.fX + pixTol && self.oX >= self.fX - pixTol && self.oY <= self.fY + pixTol && self.oY >= self.fY - pixTol) {
					self.ani_end = true;
					self._recent = '';
					self.cFlag._rs = false;
					self.cFlag._nd = true;
					self._x = self.tX;
					self._y = self.tY;
					self._sc = self.rA;
					self._w = self._sc * self.iW;
					self._h = self._sc * self.iH;
				}

				//When the image fits exactly to container size, disable the pan, zoom out and reset buttons
				if (self.rA == self.rF && self.iW * self.rA <= self.sW && self.iH * self.rA <= self.sH) {
					if (self.buttons[1].$ob.css('opacity') > 0.5) {
						if (self.rA >= self.rF && (self.init_zoom == '' || self.rA < self.init_zoom) && (self.zoom_min == '' || self.rA < self.zoom_min)) {
							if (self.pan_limit && self._moveCursor && !self._moveCursor) {
								self.$image.css('cursor', 'default');
								self.$hitArea.css('cursor', 'default');
							}
							for (var bEn = 1; bEn < (self.pan_limit && !self._moveCursor ? self.buttons_total : 2); bEn++) {
								self.buttons[bEn].$ob.css({
									'opacity': 0.4
								});
								self._wheel = false;
								self.$holder.find('#' + self.buttons[bEn]._var + 'norm').show();
								self.$holder.find('#' + self.buttons[bEn]._var + 'over').hide();
							}
						}
					}
				} else {
					if (self.buttons[1].$ob.css('opacity') < 0.5) {
						if (self._moveCursor && self.mouse_drag) {
							self.$image.css('cursor', 'move');
							self.$hitArea.css('cursor', 'move');
						}
						for (var bEn = 1; bEn < self.buttons_total; bEn++) {
							self.buttons[bEn].$ob.css('opacity', 0.7);
						}
					}
				}

				//When the image reaches max zoom, disable the zoom button
				if (self.rA == self.zoom_max) {
					if (self.buttons[0].$ob.css('opacity') > 0.5) {
						self.buttons[0].$ob.css('opacity', 0.4);
						self._wheel = false;
						self.$holder.find('#' + self.buttons[0]._var + 'norm').show();
						self.$holder.find('#' + self.buttons[0]._var + 'over').hide();
					}
				} else {
					if (self.buttons[0].$ob.css('opacity') < 0.5) {
						self.buttons[0].$ob.css('opacity', 0.7);
					}
				}

				//Apply Scale and position to the image:
				if (prop_transform) {
					self.$image.css(prop_transform, 'translate(' + self._x.toFixed(14) + 'px,' + self._y.toFixed(14) + 'px) scale(' + self._sc + ')');
				} else {
					self.$image.css({
						left: self._x,
						top: self._y,
						width: self._w,
						height: self._h
					});
				}

				if (self.$loc_cont) {
					self.updateLocations(self._x, self._y, self._sc, self.locations);
				}

				//In case image Maps used, update them
				if (!prop_transform && self.map_coordinates.length > 0) {
					self.updateMap();
				}
				//If the animation completed, stop running; else continue	
				if (self.ani_end && !self._dragging && self._recent != 'drag') {
					self._playing = false;
					self._recent = '';
					self.cX = (-self._x + self.sW / 2) / self.rA;
					self.cY = (-self._y + self.sH / 2) / self.rA;
					if (self.onUPDATE) {
						self.onUPDATE(self.getZoomData(), false);
					}
					if (self.onZOOM_PAN) {
						self.onZOOM_PAN(self.getZoomData());
					}
					clearTimeout(self.ani_timer);

					//Set new window resize values
					self.x_diff = self._x.toFixed(14);
					self.y_diff = self._y.toFixed(14);
					self.img_w = self.$image.outerWidth();
					self.img_h = self.$image.outerHeight();
				} else {
					self._playing = true;
					if (self.onUPDATE) {
						self.onUPDATE(self.getZoomData(), true);
					}
					self.ani_timer = setTimeout(function () {
						self.Animate();
					}, 28);
				}
			},

			/*Relocate the landmarks according to main image's position
   ***********************************************************************************************************************/
			updateLocations: function updateLocations(_x, _y, _sc, loc) {

				if (this.onLANDMARK !== '') {
					if (_sc >= this.show_at_zoom) {
						if (!this._landmark) {
							this._landmark = true;
							this.onLANDMARK(true);
						}
					} else {
						if (this._landmark) {
							this._landmark = false;
							this.onLANDMARK(false);
						}
					}
				}

				for (var p = 0; p < loc.length; p++) {
					var wScaled,
					    hScaled,
					    lpx = loc[p].x * _sc + _x,
					    lpy = loc[p].y * _sc + _y;

					if (_sc >= loc[p].showAt) {
						if (loc[p].scale && prop_transform) {
							wScaled = loc[p].w2pad * this._sc;
							hScaled = loc[p].h2 * this._sc;
						} else {
							wScaled = loc[p].w2pad;
							hScaled = loc[p].h2;
						}
						if (lpx > -wScaled && lpx < this.sW + wScaled && (lpy > -hScaled && lpy < this.sH + hScaled && loc[p].lab || lpy > 0 && lpy < this.sH + hScaled * 2 && !loc[p].lab)) {
							if (!loc[p].vis) {
								loc[p].vis = true;
								if (prop_transform) {
									loc[p].ob.stop().css('display', 'block').animate({
										opacity: 1
									}, 300);
								} else {
									loc[p].ob.show();
								}
							}
						} else {
							if (loc[p].vis) {
								loc[p].vis = false;
								if (prop_transform) {
									loc[p].ob.stop().animate({
										opacity: 0
									}, 200, function () {
										$(this).hide();
									});
								} else {
									loc[p].ob.hide();
								}
							}
						}
					} else {
						if (loc[p].vis) {
							loc[p].vis = false;
							if (prop_transform) {
								loc[p].ob.stop().animate({
									opacity: 0
								}, 200, function () {
									$(this).hide();
								});
							} else {
								loc[p].ob.hide();
							}
						}
					}
					if (lpx !== loc[p].lpx || lpy !== loc[p].lpy && loc[p].vis) {
						if (prop_transform) {
							loc[p].ob.css(prop_transform, 'translate(' + lpx.toFixed(14) + 'px,' + lpy.toFixed(14) + 'px)' + (loc[p].scale ? ' scale(' + this._sc + ')' : ''));
						} else {
							loc[p].ob.css({
								left: lpx,
								top: lpy
							});
						}
					}
					loc[p].lpx = lpx;
					loc[p].lpy = lpy;
				}
			},

			/*If the broswer doesn't supports css border radius, we need to go with old school png image for rounded corner
   ***********************************************************************************************************************/
			roundBG: function roundBG(el, _name, _w, _h, _r, _p, _c, _i, _z, _yoff) {
				var w = 50 / 2;

				el.append($('<div class="bgi' + _name + '" style="background-position:' + -(_p - _r) + 'px ' + (-(w - _r) - _yoff) + 'px"></div>\
				<div class="bgh' + _name + '"></div>\
				<div class="bgi' + _name + '" style="background-position:' + -_p + 'px ' + (-(w - _r) - _yoff) + 'px; left:' + (_w - _r) + 'px"></div>\
				<div class="bgi' + _name + '" style="background-position:' + -(_p - _r) + 'px ' + (-w - _yoff) + 'px; top:' + (_h - _r) + 'px"></div>\
				<div class="bgh' + _name + '" style = "top:' + (_h - _r) + 'px; left:' + _r + 'px"></div>\
				<div class="bgi' + _name + '" style="background-position:' + -_p + 'px ' + (-w - _yoff) + 'px; top:' + (_h - _r) + 'px; left:' + (_w - _r) + 'px"></div>\
				<div class="bgc' + _name + '"></div>'));
				$('.bgi' + _name).css({
					position: 'absolute',
					width: _r,
					height: _r,
					'background-image': 'url(' + _i + ')',
					'background-repeat': 'no-repeat',
					'-ms-filter': 'progid:DXImageTransform.Microsoft.gradient(startColorstr=#00FFFFFF,endColorstr=#00FFFFFF)',
					'filter': 'progid:DXImageTransform.Microsoft.gradient(startColorstr=#00FFFFFF,endColorstr=#00FFFFFF)',
					'zoom': 1
				});
				$('.bgh' + _name).css({
					position: 'absolute',
					width: _w - _r * 2,
					height: _r,
					'background-color': _c,
					left: _r
				});
				$('.bgc' + _name).css({
					position: 'absolute',
					width: _w,
					height: _h - _r * 2,
					'background-color': _c,
					top: _r,
					left: 0
				});
			},

			/*To calibrate position offset when navigation events supposed to be overlapped 
   ***********************************************************************************************************************/
			changeOffset: function changeOffset(x, y) {
				if (x) this.oX = (this.tX - (this.sW - this._w) / 2 - this.focusOffX) / (this._w / this.sW);
				if (y) this.oY = (this.tY - (this.sH - this._h) / 2 - this.focusOffY) / (this._h / this.sH);
			},

			/*Transform Image Maps (hot spots) if any
   ***********************************************************************************************************************/
			updateMap: function updateMap() {
				var self = this,
				    mapId = 0;

				self.mapAreas.each(function () {
					var new_vals = [];
					for (var i = 0; i < self.map_coordinates[mapId].length; i++) {
						new_vals[i] = self.map_coordinates[mapId][i] * self._sc;
					}
					new_vals = new_vals.join(',');
					$(this).attr('coords', new_vals);
					mapId++;
				});
			},

			/*To stop the timer loops immediatly
   ***********************************************************************************************************************/
			haltAnimation: function haltAnimation() {
				clearTimeout(this.ani_timer);
				this._playing = false;
				this._recent = '';
			},

			/*Method to Remove the plugin instance
   ***********************************************************************************************************************/
			destroy: function destroy() {
				var self = this;

				if (self.assetsLoaded) {
					self.haltAnimation();
					for (prop in self.orig_style) {
						if (self.orig_style[prop][0] !== false && self.orig_style[prop][0] !== undefined) {
							if (self.orig_style[prop][0] === 'width' || self.orig_style[prop][0] === 'height') {
								if (parseInt(self.orig_style[prop][1]) !== 0) {
									self.$image.css(self.orig_style[prop][0], self.orig_style[prop][1]);
								}
							} else {
								self.$image.css(self.orig_style[prop][0], self.orig_style[prop][1]);
							}
						}
					}
					clearTimeout(self.auto_timer);
					$(document).off('.sz' + self.id);
					$(window).off('.sz' + self.id);
					self.$holder.off('.sz');
					self.$controls = undefined;
				} else {
					self.$image.show();
				}

				if (self.container == '') {
					if (self.image_url == '') {
						self.$image.insertBefore(self.$holder);
						if (self.$holder !== undefined) {
							self.$holder.remove();
						}
					} else {
						self.$elem.empty();
						if (self.$loc_cont[0]) {
							self.$elem.append(self.loc_clone);
						}
					}
				} else {
					self.$image.insertBefore(self.$holder);
					self.$holder.empty();
					self.$image.wrap(self.$holder);
					if (self.$loc_cont[0]) {
						self.$holder.append(self.loc_clone);
					}
				}
				self.$elem.removeData('smoothZoom');
				self.$holder = undefined;
				self.Buttons = undefined;
				self.op = undefined;
				self.$image = undefined;
			},

			/*Method to change focus point and level
   ***********************************************************************************************************************/
			focusTo: function focusTo(params) {
				var self = this;

				if (self.assetsLoaded) {
					if (params.zoom === undefined || params.zoom === '' || params.zoom == 0) {
						params.zoom = self.rA;
					} else {
						params.zoom /= 100;
					}
					self._onfocus = true;
					if (params.zoom > self.rA && self.rA != self.zoom_max) {
						self.rA = params.zoom;
						self.rA = self.rA > self.zoom_max ? self.zoom_max : self.rA;
					} else if (params.zoom < self.rA && self.rA != self.rF) {
						self.rA = params.zoom;
						self.rA = self.rA < self.rF ? self.rF : self.rA;
					}
					self.transOffX = self.transOffY = 0;
					self.setDraggedPos(params.x === undefined || params.x === '' ? '' : -params.x * self.rA + self.sW / 2, params.y === undefined || params.y === '' ? '' : -params.y * self.rA + self.sH / 2, self.rA);
					self.reduction = params.speed ? params.speed / 10 : self.focusSpeed;
					self._recent = 'drag';
					self._dragging = true;
					if (!self._playing) {
						self.Animate();
					}
				}
			},

			zoomIn: function zoomIn(params) {
				this.buttons[0].$ob.trigger(this.event_down, {
					id: 0
				});
			},

			zoomOut: function zoomOut(params) {
				this.buttons[1].$ob.trigger(this.event_down, {
					id: 1
				});
			},

			moveRight: function moveRight(params) {
				this.buttons[2].$ob.trigger(this.event_down, {
					id: 2
				});
			},

			moveLeft: function moveLeft(params) {
				this.buttons[3].$ob.trigger(this.event_down, {
					id: 3
				});
			},

			moveUp: function moveUp(params) {
				this.buttons[4].$ob.trigger(this.event_down, {
					id: 4
				});
			},

			moveDown: function moveDown(params) {
				this.buttons[5].$ob.trigger(this.event_down, {
					id: 5
				});
			},

			Reset: function Reset(params) {
				this.buttons[6].$ob.trigger(this.event_down, {
					id: 6
				});
			},

			getZoomData: function getZoomData(params) {
				return {
					//x offset (without scale ratio multiplied)
					normX: (-this._x / this.rA).toFixed(14),

					//y offset (without scale ratio multiplied)
					normY: (-this._y / this.rA).toFixed(14),

					//Original image Width
					normWidth: this.iW,

					//Original image height
					normHeight: this.iH,

					//x offset (with scale ratio multiplied)
					scaledX: -this._x.toFixed(14),

					//y offset (with scale ratio multiplied)
					scaledY: -this._y.toFixed(14),

					//Scaled image width
					scaledWidth: this._w,

					//Scaled image height
					scaledHeight: this._h,

					//The X location on image which is currently on center of canvas 
					centerX: (-this._x.toFixed(14) + this.sW / 2) / this.rA,

					//The Y location on image which is currently on center of canvas 
					centerY: (-this._y.toFixed(14) + this.sH / 2) / this.rA,

					//Scale ratio
					ratio: this.rA
				};
			},

			addLandmark: function addLandmark(loc) {
				if (this.$loc_cont) {
					var total = loc.length;

					for (var i = 0; i < total; i++) {
						var $loc = $(loc[i]);
						this.$loc_cont.append($loc);
						this.setLocation($loc);
					}

					if (total > 0) {
						this.updateLocations(this._x, this._y, this._sc, this.locations);
					}
				}
			},

			attachLandmark: function attachLandmark(loc) {
				if (this.$loc_cont) {
					var total = loc.length;
					for (var i = 0; i < total; i++) {
						this.setLocation(loc[i] instanceof jQuery ? loc[i] : $('#' + loc[i]));
					}
					if (total > 0) {
						this.updateLocations(this._x, this._y, this._sc, this.locations);
					}
				}
			},

			removeLandmark: function removeLandmark(loc) {
				if (this.$loc_cont) {
					if (loc) {
						var total = loc.length;
						for (var i = 0; i < total; i++) {
							for (var j = 0; j < this.locations.length; j++) {
								if (loc[i] instanceof jQuery && this.locations[j].ob[0] == loc[i][0] || !(loc[i] instanceof jQuery) && this.locations[j].ob.attr('id') == loc[i]) {
									this.locations[j].ob.remove();
									this.locations.splice(j, 1);
									j--;
								}
							}
						}
					} else {
						if (this.locations.length > 0) {
							this.locations[this.locations.length - 1].ob.remove();
							this.locations.pop();
						}
					}
					if (total > 0) {
						this.updateLocations(this._x, this._y, this._sc, this.locations);
					}
				}
			},

			refreshAllLandmarks: function refreshAllLandmarks() {
				var self = this;
				var locs = self.$loc_cont.children('.item');
				self.show_at_zoom = parseInt(self.$loc_cont.data('show-at-zoom'), 10) / 100;
				self.allow_scale = checkBoolean(self.$loc_cont.data('allow-scale'));
				self.allow_drag = checkBoolean(self.$loc_cont.data('allow-drag'));

				//Step 1: Remove records for which the elements no longer exist
				for (var i = 0; i < self.locations.length; i++) {
					var exists = false;
					locs.each(function () {
						if (self.locations[i].ob[0] == $(this)[0]) {
							exists = true;
						}
					});
					if (!exists) {
						self.locations.splice(i, 1);
						i--;
					}
				}

				//Step 2: Add new elements to record
				locs.each(function () {
					var exists = false;
					for (var i = 0; i < self.locations.length; i++) {
						if (self.locations[i].ob[0] == $(this)[0]) {
							exists = true;
							break;
						}
					}
					if (!exists) {
						self.setLocation($(this));
					}
				});
				this.updateLocations(this._x, this._y, this._sc, this.locations);
			},

			/*On windows resize, adjust some defaults
   ***********************************************************************************************************************/
			resize: function resize(e) {
				var self;

				if (e.data) {
					e.preventDefault();
					self = e.data.self;
					var pw = self.$holder.parent().width();
					var ph = self.$holder.parent().height();

					if (self.oW) {
						pw = Math.min(pw, self.oW);
					}
					self.sW = pw;

					if (self.oH) {
						if (self.oW && self.maintain_ratio) {
							self.sH = pw / (self.oW / self.oH);
						}
					} else {
						self.sH = ph;
					}
				} else {
					self = this;
					if (e.width) {
						self.sW = e.width;
					}
					if (e.height) {
						self.sH = e.height;
					}
					if (e.max_WIDTH) {
						self.w_max = e.max_WIDTH;
					}
					if (e.max_HEIGHT) {
						self.h_max = e.max_HEIGHT;
					}
				}
				if (self.w_max !== 0 && self.w_max !== '') {
					self.sW = Math.min(self.sW, self.w_max);
				}
				if (self.h_max !== 0 && self.h_max !== '') {
					self.sH = Math.min(self.sH, self.h_max);
				}
				self.$holder.css({
					'width': self.sW,
					'height': self.sH
				});
				if (self.bord_size > 0) {
					self.border[0].height(self.sH);
					self.border[1].css({
						height: self.sH,
						left: self.sW - self.bord_size
					});
					self.border[2].width(self.sW - self.bord_size * 2);
					self.border[3].css({
						width: self.sW - self.bord_size * 2,
						top: self.sH - self.bord_size
					});
				}
				if (self.bu_align[1] == 'center') {
					self.$controls.css('left', parseInt((self.sW - self.cBW) / 2));
				}
				if (self.bu_align[0] == 'center') {
					self.$controls.css('top', parseInt((self.sH - self.cBH) / 2));
				}
				self.rF = self.rR = self.checkRatio(self.sW, self.sH, self.iW, self.iH, self.zoom_fit);
				if (self.zoom_min == 0) {
					if (self.rA < self.rF) {
						self.rA = self.rF;
					}
				}

				//Set values to keep center focused

				var img_p = self.$image.position();
				var img_w = self.$image.outerWidth();
				var img_h = self.$image.outerHeight();

				var img_x = parseFloat(self.x_diff || img_p.left) / (self.img_w || img_w) * img_w;
				var img_y = parseFloat(self.y_diff || img_p.top) / (self.img_h || img_h) * img_h;

				if (self.resizeInit) {
					self.setDraggedPos(img_x, img_y, self._sc, true);
					self._recent = 'drag';
					self._dragging = true;
					if (!self._playing) {
						self.Animate();
					}
				} else {
					//clearTimeout(self.ani_timer);
					self.resizeInit = true;
					self.img_w = img_w;
					self.img_h = img_h;
					self.x_diff = img_p.left;
					self.y_diff = img_p.top;
				}

				clearTimeout(self.resizeTimer);
				self.resizeTimer = setTimeout(function () {
					//self._playing = false;
					self._dragging = false;
				}, 100);

				/*self.focusTo({
    	x: self.cX,
    	y: self.cY,
    	zoom:'',
    	speed: 10,
    });*/
			}
		};

		$.fn.smoothZoom = function (params) {
			var self = this;
			var l = self.length;

			//For single or more than one plugin instance
			for (var i = 0; i < l; i++) {
				var $elem = $(self[i]);
				var instance = $elem.data('smoothZoom');

				// Case 1: Initiate the plugin if not already have an instance
				if (!instance) {

					if ((typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object' || !params) {
						$elem.data('smoothZoom', new Zoomer($elem, params));
					}

					// Case 2: If the instance already available - Check for method call
				} else {

					// getZoomData - Returns {sourceX, sourceY, sourceWidth, sourceHeight, distX, distY, distWidth, distHeight, centerX, centerY, ratio}				
					if (params == 'getZoomData') {
						return instance[params].apply(instance, Array.prototype.slice.call(arguments, 1));

						// destroy | focusTo | zoomIn | zoomOut | moveRight| moveLeft | moveUp | moveDown | Reset | addLandmark | removeLandmark | attachLandmark | refreshAllLandmarks
					} else if (instance[params]) {
						instance[params].apply(instance, Array.prototype.slice.call(arguments, 1));
					}
				}
			}

			//return for chainability for possible cases
			if (params !== 'getZoomData') {
				return this;
			}
		};

		function checkBoolean(_var) {
			if (_var === true) {
				return true;
			} else if (_var) {
				_var = _var.toLowerCase();
				if (_var == 'yes' || _var == 'true') {
					return true;
				}
			}
			return false;
		}

		//...................................................................................................................
		//Using Modernizr to check browser capabilities and property names prefixed

		/* Modernizr 2.5.3 (Custom Build) | MIT & BSD
   * Build: http://www.modernizr.com/download/#-borderradius-csstransforms-csstransforms3d-touch-prefixed-teststyles-testprop-testallprops-prefixes-domprefixes
  	*/
		//var Modernizr=function(a,b,c){function y(a){i.cssText=a}function z(a,b){return y(l.join(a+";")+(b||""))}function A(a,b){return typeof a===b}function B(a,b){return!!~(""+a).indexOf(b)}function C(a,b){for(var d in a)if(i[a[d]]!==c)return b=="pfx"?a[d]:!0;return!1}function D(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:A(f,"function")?f.on(d||b):f}return!1}function E(a,b,c){var d=a.charAt(0).toUpperCase()+a.substr(1),e=(a+" "+n.join(d+" ")+d).split(" ");return A(b,"string")||A(b,"undefined")?C(e,b):(e=(a+" "+o.join(d+" ")+d).split(" "),D(e,b,c))}var d="2.5.3",e={},f=b.documentElement,g="modernizr",h=b.createElement(g),i=h.style,j,k={}.toString,l=" -webkit- -moz- -o- -ms- ".split(" "),m="Webkit Moz O ms",n=m.split(" "),o=m.toLowerCase().split(" "),p={},q={},r={},s=[],t=s.slice,u,v=function(a,c,d,e){var h,i,j,k=b.createElement("div"),l=b.body,m=l?l:b.createElement("body");if(parseInt(d,10))while(d--)j=b.createElement("div"),j.id=e?e[d]:g+(d+1),k.appendChild(j);return h=["&#173;","<style>",a,"</style>"].join(""),k.id=g,(l?k:m).innerHTML+=h,m.appendChild(k),l||(m.style.background="",f.appendChild(m)),i=c(k,a),l?k.parentNode.removeChild(k):m.parentNode.removeChild(m),!!i},w={}.hasOwnProperty,x;!A(w,"undefined")&&!A(w.call,"undefined")?x=function(a,b){return w.call(a,b)}:x=function(a,b){return b in a&&A(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=t.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(t.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(t.call(arguments)))};return e});var F=function(c,d){var f=c.join(""),g=d.length;v(f,function(c,d){var f=b.styleSheets[b.styleSheets.length-1],h=f?f.cssRules&&f.cssRules[0]?f.cssRules[0].cssText:f.cssText||"":"",i=c.childNodes,j={};while(g--)j[i[g].id]=i[g];e.touch="ontouchstart"in a||a.DocumentTouch&&b instanceof DocumentTouch||(j.touch&&j.touch.offsetTop)===9,e.csstransforms3d=(j.csstransforms3d&&j.csstransforms3d.offsetLeft)===9&&j.csstransforms3d.offsetHeight===3},g,d)}([,["@media (",l.join("touch-enabled),("),g,")","{#touch{top:9px;position:absolute}}"].join(""),["@media (",l.join("transform-3d),("),g,")","{#csstransforms3d{left:9px;position:absolute;height:3px;}}"].join("")],[,"touch","csstransforms3d"]);p.touch=function(){return e.touch},p.borderradius=function(){return E("borderRadius")},p.csstransforms=function(){return!!E("transform")},p.csstransforms3d=function(){var a=!!E("perspective");return a&&"webkitPerspective"in f.style&&(a=e.csstransforms3d),a};for(var G in p)x(p,G)&&(u=G.toLowerCase(),e[u]=p[G](),s.push((e[u]?"":"no-")+u));return y(""),h=j=null,e._version=d,e._prefixes=l,e._domPrefixes=o,e._cssomPrefixes=n,e.testProp=function(a){return C([a])},e.testAllProps=E,e.testStyles=v,e.prefixed=function(a,b,c){return b?E(a,b,c):E(a,"pfx")},e}(this,this.document);

		var prop_transform = Modernizr.prefixed('transform');
		var prop_origin = Modernizr.prefixed('transformOrigin');
		var prop_radius = Modernizr.prefixed('borderRadius');
		var supportsTrans3D = Modernizr.csstransforms3d;
		//var supportsTouch = Modernizr.touch;
		var supportsTouch = $('html.screen--is-touch').length;

		//})(jQuery, window, document);

	};

	init();return api;
};

//End - smoothZoom

//...................................................................................................................
//For mouse wheel support

/*! Copyright (c) 2011 Brandon Aaron (http://brandonaaron.net)
 * Licensed under the MIT License (LICENSE.txt).
 *
 * Thanks to: http://adomas.org/javascript-mouse-wheel/ for some pointers.
 * Thanks to: Mathias Bank(http://www.mathias-bank.de) for a scope bug fix.
 * Thanks to: Seamus Leahy for adding deltaX and deltaY
 *
 * Version: 3.0.6
 * 
 * Requires: 1.2.2+
 */
//(function(a){function d(b){var c=b||window.event,d=[].slice.call(arguments,1),e=0,f=!0,g=0,h=0;return b=a.event.fix(c),b.type="mousewheel",c.wheelDelta&&(e=c.wheelDelta/120),c.detail&&(e=-c.detail/3),h=e,c.axis!==undefined&&c.axis===c.HORIZONTAL_AXIS&&(h=0,g=-1*e),c.wheelDeltaY!==undefined&&(h=c.wheelDeltaY/120),c.wheelDeltaX!==undefined&&(g=-1*c.wheelDeltaX/120),d.unshift(b,e,g,h),(a.event.dispatch||a.event.handle).apply(this,d)}var b=["DOMMouseScroll","mousewheel"];if(a.event.fixHooks)for(var c=b.length;c;)a.event.fixHooks[b[--c]]=a.event.mouseHooks;a.event.special.mousewheel={setup:function(){if(this.addEventListener)for(var a=b.length;a;)this.addEventListener(b[--a],d,!1);else this.onmousewheel=d},teardown:function(){if(this.remove_eventListener)for(var a=b.length;a;)this.remove_eventListener(b[--a],d,!1);else this.onmousewheel=null}},a.fn.extend({mousewheel:function(a){return a?this.on("mousewheel",a):this.trigger("mousewheel")},unmousewheel:function(a){return this.off("mousewheel",a)}})})(jQuery)

//...................................................................................................................

app.globalExt['textinput'] = function () {
	var api = {};

	var $textinputs = $('.textinput input[type=text], .textinput textarea');

	var init = function init() {
		$textinputs.on('blur', function () {
			if ($(this).val() !== '') {
				$(this).addClass('filled');
			} else {
				$(this).removeClass('filled');
			}
		});
	};

	init();return api;
};

app.ext['add-quote'] = function ($el) {
	var api = {};

	var quote = $el.find('p').last().text().trim();

	var init = function init() {
		$el.find('p').last().text(quote + '\"');
	};

	init();return api;
};

app.ext['benefits'] = function ($el) {
	var api = {};

	var $benefitsItems = $el.find('.benefits__list ul li');
	var $benefitsContent = $el.find('.benefits__content');
	var $benefitsRight = $el.find('.benefits__right');

	var $benefitsHeadline = $el.find('.benefits__headline');

	var init = function init() {
		addEventListeners();
		calcHeight();
	};

	var addEventListeners = function addEventListeners() {
		$el.on('click', showInitialState);
		$benefitsRight.on('click', function () {
			return false;
		});
		$benefitsItems.on('click', toggleBenefit);
		$(window).on('resize', calcHeight);
	};

	var toggleBenefit = function toggleBenefit(e) {
		e.preventDefault();
		e.stopPropagation();
		$benefitsContent.filter('.active').removeClass('active');
		$benefitsItems.filter('.active').removeClass('active');

		var $this = $(this);

		var selector = $this.data('itemid');

		var $matchingBenefit = $el.find('.benefits__content[data-item="' + selector + '"]');

		$this.addClass('active');
		$matchingBenefit.addClass('active');
	};

	var showInitialState = function showInitialState(e) {
		$benefitsContent.filter('.active').removeClass('active');
		$benefitsItems.filter('.active').removeClass('active');
		$el.find('.benefits__content[data-item="standard"]').addClass('active');
	};

	var calcHeight = function calcHeight() {
		var highest = null;
		var hi = 0;
		var top = parseInt($benefitsContent.css('top'), 10);
		$benefitsContent.each(function () {
			var h = $(this).outerHeight();
			if (h > hi) {
				hi = h;
				highest = $(this);
			}
		});

		$benefitsRight.css({
			minHeight: hi + 100 + top
		});
	};

	init();return api;
};

app.ext['burgermenu'] = function ($el) {
	var api = {};

	var $menu = $('.header__navigation');
	var $dropdown = $('.header__dropdown');

	var $mobileSearch = $('.header__mobile .header__search');

	var $backlink = $('.header__sony .back');

	var init = function init() {
		$el.on('click', toggleMenu);
	};

	var toggleMenu = function toggleMenu() {
		if ($menu.hasClass('active')) {
			$('body').removeClass('noscroll');
			$mobileSearch.removeClass('invisible');
			$menu.removeClass('active slideoutleft');
			$el.removeClass('active');
			$dropdown.removeClass('active');
			$backlink.removeClass('inscreen');
		} else {
			$('body').addClass('noscroll');
			$mobileSearch.addClass('invisible');
			$menu.addClass('active');
			$el.addClass('active');
		}
	};

	init();return api;
};

app.ext['callback'] = function ($el) {
	var api = {};

	var $matchingOverlay = $el.parents().find('.js-overlay').first();

	var $requiredTextFields = $el.find('#name, #phone, #message');

	var $submitButton = $el.find('button[type=submit]');

	var $successMessage = $el.find('.js-callback-success');

	var valid = false;

	var validArray = [];

	var action = $el.attr('action');
	var method = $el.attr('method');

	var init = function init() {
		$submitButton.on('click', checkIfSubmitable);
		$requiredTextFields.on('change', function () {
			checkTextError($(this));
		});
	};

	var checkIfSubmitable = function checkIfSubmitable() {
		validateFields();
		validArray.push(isCaptchaChecked());
		validArray.push(isTermsChecked());
		valid = validArray.every(checkTrue);
		if (valid) {
			$.ajax({
				type: method,
				url: action,
				data: $el.serialize(), // serializes the form's elements.
				complete: function complete(data, status) {
					$successMessage.text(data.responseText).fadeIn(200);
					if (isScrollable($matchingOverlay)) {
						$matchingOverlay.animate({ scrollTop: $matchingOverlay.height() }, 1000);
						$('.overlay__close--success').fadeIn(100);
					}

					$('.overlay__close--success, .overlay__close, .overlayshade').on('click', function () {
						$el.get(0).reset();
						grecaptcha.reset();
						setTimeout(function () {
							$successMessage.hide();
							$('.overlay__close--success').hide();
						}, 300);
					});
				}
			});
		}
		return false;
	};

	var validateFields = function validateFields() {
		validArray = [];

		$requiredTextFields.each(function () {
			var $this = $(this);
			checkTextError($this);
		});
	};

	var checkTextError = function checkTextError($this) {
		if ($this.val() === '') {
			$this.addClass('error');
			validArray.push(false);
		} else {
			$this.removeClass('error');
			validArray.push(true);
		}
	};

	function checkTrue(con) {
		return con === true;
	}

	function isCaptchaChecked() {
		if (grecaptcha && grecaptcha.getResponse().length !== 0) {
			$el.find('.g-recaptcha').removeClass('error');
			return true;
		} else {
			$el.find('.g-recaptcha').addClass('error');
			return false;
		}
	}

	function isTermsChecked() {

		if ($('#privacy').is(":checked")) {
			$('#privacy').removeClass('error');
			return true;
		} else {
			$('#privacy').addClass('error');
			return false;
		}
	}

	function isScrollable(t) {
		return t.get(0).scrollHeight > t.height();
	}

	init();return api;
};

app.ext['casestudies'] = function ($el) {
	var api = {};

	var slider = void 0;

	var slidescount = $el.find('.swiper-slide').length;

	var $wrapper = $el.find('.swiper-wrapper');

	var init = function init() {
		resizeHandler();
		$(window).on('resize', resizeHandler);
	};

	var resizeHandler = function resizeHandler() {
		if (window.innerWidth > 1279 && slidescount > 3 || window.innerWidth > 767 && window.innerWidth < 1280 && slidescount > 2 || window.innerWidth < 768 && slidescount > 1) {
			if (!slider) {
				initSwiper();
			}
			$('.js-casestudies-button').show();
			$('.js-casestudies-pagination').show();
		} else {
			if (slider) {
				slider.destroy();
			}
			$('.js-casestudies-button').hide();
			$('.js-casestudies-pagination').hide();
		}

		if (slidescount === 1 || slidescount === 2 && window.innerWidth > 767) {
			$wrapper.addClass('centered');
		} else {
			$wrapper.removeClass('centered');
		}
	};

	var initSwiper = function initSwiper() {
		slider = new Swiper('.js-casestudies', {
			slidesPerView: 'auto',
			pagination: {
				el: '.js-casestudies-pagination',
				clickable: true
			},
			navigation: {
				nextEl: '.js-casestudies-button-next',
				prevEl: '.js-casestudies-button-prev'
			}
		});
	};

	init();return api;
};

app.ext['cookiebanner'] = function ($el) {
	var api = {};

	var $close = $el.find('.cookie-banner__close');

	var cookieAccepted = document.cookie.indexOf('cookiesAccepted=') > -1;

	var init = function init() {
		if (!cookieAccepted) {
			$el.slideDown(200);
			setTimeout(function () {
				$('body').css({
					marginBottom: $el.outerHeight()
				});
			}, 200);
		}
		$close.on('click', hideCookiebanner);
	};

	var hideCookiebanner = function hideCookiebanner() {
		createCookie();
		$el.slideUp(200);
		$('body').css({
			marginBottom: 0
		});
		cookieAccepted = true;
	};

	var createCookie = function createCookie() {
		var expiration_date = new Date();
		var cookie_string = '';
		expiration_date.setFullYear(expiration_date.getFullYear() + 1);
		cookie_string = "cookiesAccepted=true; path=/; expires=" + expiration_date.toUTCString();
		document.cookie = cookie_string;
	};

	init();return api;
};

app.ext['countup'] = function ($el) {
	var api = {};

	var start = $el.data('start');
	var end = $el.data('end');

	var $number = $el.find('.stats__number');

	var offsetTop = $el.offset().top + $el.outerHeight() / 2 - window.innerHeight;

	var done = false;

	var init = function init() {
		$(window).on('scroll', countUp);
		countUp();
	};

	var countUp = function countUp() {
		if (!done && $(window).scrollTop() > offsetTop) {
			done = true;
			$({ countNum: $number.text() }).animate({
				countNum: end
			}, {

				duration: 2000,
				easing: 'linear',
				step: function step() {
					$number.text(Math.floor(this.countNum).toLocaleString('de'));
				},
				complete: function complete() {
					$number.text(this.countNum.toLocaleString('de'));
				}

			});
		}
	};

	init();return api;
};

app.ext['datepicker'] = function ($el) {
	var api = {};

	var init = function init() {
		$el.datepicker({
			changeMonth: true,
			changeYear: true,
			yearRange: '-90:+0',
			dateFormat: 'dd.mm.yy'
		});
	};

	init();return api;
};

app.ext['descriptionslider'] = function ($el) {
	var api = {};

	var swiper = void 0;

	var init = function init() {
		swiper = new Swiper('.js-descriptionslider.swiper-container', {
			slidesPerView: 1,
			spaceBetween: 20,
			loop: false,
			pagination: {
				el: '.description-slider__pagination',
				clickable: true
			},
			navigation: {
				nextEl: '.description-slider__next',
				prevEl: '.description-slider__prev'
			},
			on: {
				slideChangeTransitionStart: function slideChangeTransitionStart() {
					this.pagination.render();
					this.pagination.update();
				}
			}
		});
	};

	init();return api;
};

app.ext['dropdown'] = function ($el) {
	var api = {};

	var init = function init() {
		initSelect2();
		addListeners();
	};

	var initSelect2 = function initSelect2() {
		if ($el.hasClass('blackselect')) {
			$el.select2({
				theme: "black",
				placeholder: 'Language',
				minimumResultsForSearch: -1
			});
		} else {
			$el.select2({
				theme: "normal",
				placeholder: 'Bitte auswählen',
				minimumResultsForSearch: -1
			});
		}
	};

	var addListeners = function addListeners() {
		if ($el.data('dropdown-link-on-select')) {
			$el.on('change', function () {
				window.location.href = $el.val();
			});
		}
	};

	init();
	return api;
};

app.ext['event'] = function ($el) {
	var api = {};

	var $overlay = $el.find('.overlay--event');
	var $event = $el.find('.single-event');
	var $shade = $el.find('.overlayshade');

	var init = function init() {
		$event.on('click', openOverlay);
	};

	var openOverlay = function openOverlay(e) {
		e.preventDefault();

		//$overlay.addClass('active')
		setTimeout(function () {
			$overlay.animate({ marginRight: 0 }, 300);
		}, 0);
		$shade.addClass('active');

		$('body, html').scrollTop($(window).scrollTop() + 1);

		setTimeout(function () {
			$('body').addClass('noscroll');
		}, 10);
	};

	init();return api;
};

app.ext['fileupload'] = function ($el) {
	var api = {};

	var $input = $el.find('input');

	var $placeholder = $el.find('.fileupload__placeholder');

	var $filenameholder = $el.find('.fileupload__filenameholder');

	var $selectfile = $el.find('.fileupload__selectfile');
	var $removefile = $el.find('.fileupload__removefile');

	var init = function init() {
		$input.on('change', writeFile);
		$removefile.on('click', removeFile);
	};

	var writeFile = function writeFile() {
		var filename = $input.val().split(/(\\|\/)/g).pop();

		if (filename !== '') {
			$filenameholder.text(filename).show();
			$placeholder.hide();
			$selectfile.hide();
			$removefile.show();
		} else {
			$filenameholder.text('').hide();
			$placeholder.show();
			$selectfile.show();
			$removefile.hide();
		}
	};

	var removeFile = function removeFile(e) {
		e.preventDefault();

		$input.val(null);

		writeFile();
	};

	init();return api;
};

app.ext['findcontact'] = function ($el) {
	var api = {};

	var contacts = void 0;
	var chosenSolution = void 0;
	var chosenTopic = void 0;
	var chosenCountry = void 0;

	var slider = void 0;

	var dataUrl = $el.data('apidata');

	var $solutionsContainer = $el.find('.find-contact__solutions');

	var $stepOneContainer = $el.find('.find-contact__topics');
	var $stepOneBreadcrumbs = $stepOneContainer.siblings('.find-contact__breadcrumbs');

	var $stepTwoContainer = $el.find('.find-contact__countries');
	var $stepTwoBreadcrumbs = $stepTwoContainer.siblings('.find-contact__breadcrumbs');

	var $contactsContainer = $el.find('.find-contact__contacts');
	var $contactsBreadcrumbs = $contactsContainer.siblings('.find-contact__breadcrumbs');

	var init = function init() {

		var callback = $.getJSON(dataUrl, function (data) {
			contacts = data;
			renderSolutions();
			initSwiperSlider();
			$(document).on('click', '*[data-index]', slideToIndex);
		}).fail(function () {
			console.log("error");
		});
	};

	var renderSolutions = function renderSolutions() {
		var solutionString = void 0;
		for (var i in contacts) {
			solutionString = createSolutionString(contacts[i].image, i, contacts[i].class, contacts[i].hasOwnProperty('stepone'));
			$solutionsContainer.append(solutionString);
		}
		$solutionsContainer.on('click', '.find-contact__solution', chooseRenderingStepOne);
	};

	var chooseRenderingStepOne = function chooseRenderingStepOne() {
		var $this = $(this);

		if ($this.data('hasstepone')) {
			renderStepOne($this);
		} else {
			renderContactsImmediatly($this);
		}
	};

	var chooseRenderingStepTwo = function chooseRenderingStepTwo() {
		var $this = $(this);

		if ($this.data('hassteptwo')) {
			renderStepTwo($this);
		} else {
			renderContactsAfterStepTwo($this);
		}
	};

	var renderStepOne = function renderStepOne($this) {
		var id = $this.data('id');
		var tileString = void 0;
		chosenSolution = id;
		var stepOneContents = contacts[chosenSolution].stepone.fields;
		var stepOneName = contacts[chosenSolution].stepone.stepname;
		$stepOneContainer.empty();
		$stepOneBreadcrumbs.empty();
		for (var j in stepOneContents) {
			tileString = createTileString(j, contacts[chosenSolution].stepone.fields[j].hasOwnProperty('steptwo'));
			$stepOneContainer.append(tileString);
		}
		var crumbString = '\n            <span class="prevBlue" data-index="0">' + chosenSolution + '</span>\n            <span class="icon icon--arrow-right"></span> \n            Select ' + stepOneName + '\n        ';
		$stepOneBreadcrumbs.append(crumbString);
		slider.slideTo(1);
		$stepOneContainer.on('click', '.find-contact__tile', chooseRenderingStepTwo);
	};

	var renderStepTwo = function renderStepTwo($this) {
		var id = $this.data('id');
		var tileString = void 0;
		chosenTopic = id;
		var stepTwoContents = contacts[chosenSolution].stepone.fields[chosenTopic].steptwo.fields;
		var stepTwoName = contacts[chosenSolution].stepone.fields[chosenTopic].steptwo.stepname;
		$stepTwoContainer.empty();
		$stepTwoBreadcrumbs.empty();
		for (var k in stepTwoContents) {
			tileString = createTileString(k);
			$stepTwoContainer.append(tileString);
		}
		var crumbString = '\n        <span class="prevBlue" data-index="0">' + chosenSolution + '</span>\n        <span class="prevBlue icon icon--arrow-right"></span>\n        <span class="prevBlue" data-index="1">' + chosenTopic + '</span>\n        <span class="icon icon--arrow-right"></span>\n        Select ' + stepTwoName + '\n        ';

		$stepTwoBreadcrumbs.append(crumbString);
		slider.slideTo(2);
		$stepTwoContainer.on('click', '.find-contact__tile', renderContacts);
	};

	var renderContacts = function renderContacts() {
		var $this = $(this);
		var id = $this.data('id');
		var contactString = void 0;
		var personsString = void 0;
		chosenCountry = id;
		var foundContacts = contacts[chosenSolution].stepone.fields[chosenTopic].steptwo.fields[chosenCountry].contacts;
		var foundPersons = contacts[chosenSolution].stepone.fields[chosenTopic].steptwo.fields[chosenCountry].persons;
		$contactsContainer.empty();
		$contactsBreadcrumbs.empty();
		$.each(foundContacts, function () {
			var that = $(this)[0];
			contactString = createContactString(that.name, that.offers, that.linkto, that.street, that.zip, that.city, that.country, that.phone, that.mobile, that.email, that.fax);
			$contactsContainer.append(contactString);
		});

		$.each(foundPersons, function () {
			var thut = $(this)[0];
			personsString = createPersonString(thut.imgurl, thut.name, thut.position, thut.phone, thut.email, thut.mobile, thut.fax);
			$contactsContainer.append(personsString);
		});

		var crumbString = '\n        ' + (chosenSolution ? '\n        <span class="prevBlue" data-index="0">' + chosenSolution + '</span>\n        <span class="prevBlue icon icon--arrow-right"></span>\n        ' : '') + '\n\n        ' + (chosenTopic ? '\n        <span class="prevBlue" data-index="1">' + chosenTopic + '</span>\n        <span class="prevBlue icon icon--arrow-right"></span>\n        ' : '') + '\n\n        <span class="prevBlue" data-index="2">' + chosenCountry + '</span>\n        <span class="prevBlue icon icon--arrow-right"></span>\n        <span class="prevBlue">Your Contact</span>\n        ';
		$contactsBreadcrumbs.append(crumbString);
		slider.slideTo(3);
	};

	var renderContactsImmediatly = function renderContactsImmediatly($this) {
		var id = $this.data('id');
		var contactString = void 0;
		var personsString = void 0;
		chosenSolution = id;
		var foundContacts = contacts[chosenSolution].contacts;
		var foundPersons = contacts[chosenSolution].persons;
		$contactsContainer.empty();
		$contactsBreadcrumbs.empty();
		$.each(foundContacts, function () {
			var that = $(this)[0];
			contactString = createContactString(that.name, that.offers, that.linkto, that.street, that.zip, that.city, that.country, that.phone, that.mobile, that.email, that.fax);
			$contactsContainer.append(contactString);
		});

		$.each(foundPersons, function () {
			var thut = $(this)[0];
			personsString = createPersonString(thut.imgurl, thut.name, thut.position, thut.phone, thut.email, thut.mobile, thut.fax);
			$contactsContainer.append(personsString);
		});

		var crumbString = '\n        <span class="prevBlue" data-index="0">' + chosenSolution + '</span>\n        <span class="prevBlue icon icon--arrow-right"></span>\n        <span class="prevBlue">Your Contact</span>\n        ';

		$contactsBreadcrumbs.append(crumbString);
		slider.slideTo(3);
	};

	var renderContactsAfterStepTwo = function renderContactsAfterStepTwo($this) {
		var id = $this.data('id');
		var contactString = void 0;
		var personsString = void 0;
		chosenTopic = id;
		var foundContacts = contacts[chosenSolution].stepone.fields[chosenTopic].contacts;
		var foundPersons = contacts[chosenSolution].stepone.fields[chosenTopic].persons;
		$contactsContainer.empty();
		$contactsBreadcrumbs.empty();
		$.each(foundContacts, function () {
			var that = $(this)[0];
			contactString = createContactString(that.name, that.offers, that.linkto, that.street, that.zip, that.city, that.country, that.phone, that.mobile, that.email, that.fax);
			$contactsContainer.append(contactString);
		});

		$.each(foundPersons, function () {
			var thut = $(this)[0];
			personsString = createPersonString(thut.imgurl, thut.name, thut.position, thut.phone, thut.email, thut.mobile, thut.fax);
			$contactsContainer.append(personsString);
		});

		var crumbString = '\n        <span class="prevBlue" data-index="0">' + chosenSolution + '</span>\n        <span class="prevBlue icon icon--arrow-right"></span>\n        <span class="prevBlue" data-index="1">' + chosenTopic + '</span>\n        <span class="prevBlue icon icon--arrow-right"></span>\n        <span class="prevBlue">Your Contact</span>\n        ';

		$contactsBreadcrumbs.append(crumbString);
		slider.slideTo(3);
	};

	var createSolutionString = function createSolutionString(image, name, className, hasStepone) {
		return '\n            <div class="find-contact__solution ' + className + '" data-id="' + name + '" data-hasstepone="' + hasStepone + '">\n                <img src="' + image + '" alt="' + name + '">\n                <span>' + name + '</span>\n            </div>\n        ';
	};

	var createTileString = function createTileString(name, hasSteptwo) {
		return '\n            <div class="find-contact__tile" data-id="' + name + '" data-hassteptwo="' + hasSteptwo + '">\n                <span>' + name + '</span>\n            </div>\n        ';
	};

	var createContactString = function createContactString(name, offers, url, street, zip, city, country, phone, mobile, email, fax) {
		return '\n        <div class="single-sitelocation">\n        \n            <div class="single-sitelocation__head">\n        \n                <div class="single-sitelocation__name">\n                    <span class="icon icon--pin">\n                    </span>\n                    ' + name + '\n                </div>\n        \n                <div class="single-sitelocation__offers">\n                    ' + offers + '\n                </div>\n        \n            </div>\n        \n            <div class="single-sitelocation__body">\n        \n                <div class="single-sitelocation__address">\n                    <div class="single-sitelocation__address__headline">\n                        Address\n                    </div>\n                    <div class="single-sitelocation__address__content">\n                        ' + street + '<br>\n                        ' + zip + ' ' + city + '<br>\n                        ' + country + '\n                    </div>\n                </div>\n        \n                ' + (phone || mobile || email || fax ? '\n                <div class="single-sitelocation__contacts">\n                    <div class="single-sitelocation__contacts__headline">\n                        Contact\n                    </div>\n                    <div class="single-sitelocation__contacts__content">\n                        ' + (email ? '\n                            <div class="single-sitelocation__contacts__row">\n                                <span class="descriptioner">E-Mail:</span> <a href="mailto:' + email + '">' + email + '</a>\n                            </div>\n                        ' : '') + '\n                        ' + (phone ? '\n                            <div class="single-sitelocation__contacts__row">\n                                <span class="descriptioner">Phone:</span> <a href="tel:' + phone + '">' + phone + '</a>\n                            </div>\n                        ' : '') + '\n                        ' + (mobile ? '\n                            <div class="single-sitelocation__contacts__row">\n                                <span class="descriptioner">Mobile:</span> <a href="tel:' + mobile + '">' + mobile + '</a>\n                            </div>\n                        ' : '') + '\n                        ' + (fax ? '\n                            <div class="single-sitelocation__contacts__row">\n                                <span class="descriptioner">Fax:</span> <span>' + fax + '</span>\n                            </div>\n                        ' : '') + '\n                    </div>\n                </div>\n                ' : '') + '\n            </div>\n\n            ' + (url ? '\n            <div class="single-sitelocation__button">\n                <a href="' + url + '" class="button button--border"><span>View More</span></a>\n            </div>\n            ' : '') + '\n            \n        </div> \n        ';
	};

	var createPersonString = function createPersonString(imgurl, name, position, phone, email, mobile, fax) {
		return '\n        <div class="single-contact">\n            <div class="single-contact__imagename">\n                <div class="single-contact__avatar" style="background-image: url(' + imgurl + ')"></div>\n\n                <div class="single-contact__name">\n                    <div class="copy copy--small copy--bold">\n                        ' + name + '\n                    </div>\n                    <div class="copy copy--small">\n                        ' + position + '\n                    </div>\n                </div>\n            </div>\n\n            <div class="single-contact__content">\n                ' + (email ? '\n                    <div class="copy copy--small single-contact__row">\n                        <span class="descriptioner">E-Mail:</span>\n                        <a href="mailto:' + email + '">' + email + '</a>\n                    </div>\n                ' : '') + '\n\n                ' + (phone ? '\n                    <div class="copy copy--small single-contact__row">\n                        <span class="descriptioner">Phone:</span>\n                        <a href="tel:' + phone + '">' + phone + '</a>\n                    </div>\n                ' : '') + '\n\n                ' + (mobile ? '\n                    <div class="copy copy--small single-contact__row">\n                        <span class="descriptioner">Mobile:</span>\n                        <a href="tel:' + mobile + '">' + mobile + '</a>\n                    </div>\n                ' : '') + '\n\n                ' + (fax ? '\n                    <div class="copy copy--small single-contact__row">\n                        <span class="descriptioner">Fax:</span>\n                        <span>' + fax + '</span>\n                    </div>\n                ' : '') + '\n            </div>\n        </div>\n        ';
	};

	var slideToIndex = function slideToIndex() {
		var $this = $(this);
		slider.slideTo($this.data('index'));
	};

	var initSwiperSlider = function initSwiperSlider() {
		slider = new Swiper('.find-contact__content', {
			slidesPerView: 1,
			simulateTouch: false,
			allowTouchMove: false,
			autoHeight: true
		});
	};

	init();return api;
};

app.ext['form'] = function ($el) {
	var api = {};

	var $requiredTextFields = $el.find('input[type=text], select').filter('[required]');
	var $requiredFileFields = $el.find('input[type=file]').filter('[required]');
	var $requiredCheckFields = $el.find('input[type=checkbox]').filter('[required]');

	var $submitButton = $el.find('input[type=submit]');

	var $formError = $el.find('.form__error');
	var $formErrorClose = $formError.find('.form__error__close');

	var $privacyInfo = $el.find('.overlay-privacy');
	var $overlay = $('.overlay--form');

	var valid = false;

	var validArray = [];

	var init = function init() {
		$submitButton.on('click', checkIfSubmitable);
		$requiredTextFields.on('change', function () {
			checkTextError($(this));
		});
		$requiredFileFields.on('change', function () {
			checkFileError($(this));
		});
		$requiredCheckFields.on('change', function () {
			checkCheckError($(this));
		});
		$('input[name=gender]').on('change', checkRadioError);

		$formErrorClose.on('click', function () {
			$formError.removeClass('active');
		});

		$privacyInfo.on('click', openOverlay);
	};

	var checkIfSubmitable = function checkIfSubmitable() {
		validateFields();
		valid = validArray.every(checkTrue);
		if (!valid) $formError.addClass('active');
		return valid;
	};

	var validateFields = function validateFields() {
		validArray = [];

		$requiredTextFields.each(function () {
			var $this = $(this);
			checkTextError($this);
		});

		$requiredCheckFields.each(function () {
			var $this = $(this);
			checkCheckError($this);
		});

		$requiredFileFields.each(function () {
			var $this = $(this);
			checkFileError($this);
		});

		checkRadioError();
	};

	var checkTextError = function checkTextError($this) {
		if ($this.val() === '') {
			$this.addClass('error');
			validArray.push(false);
		} else {
			$this.removeClass('error');
			validArray.push(true);
		}
	};

	var checkCheckError = function checkCheckError($this) {
		if ($this.is(':not(:checked)')) {
			$this.addClass('error');
			validArray.push(false);
		} else {
			$this.removeClass('error');
			validArray.push(true);
		}
	};

	var checkFileError = function checkFileError($this) {
		if ($this.val() === '') {
			$this.parent().addClass('error');
			validArray.push(false);
		} else {
			$this.parent().removeClass('error');
			validArray.push(true);
		}
	};

	var checkRadioError = function checkRadioError() {
		if ($('input[name=gender]:checked').length > 0) {
			$('input[name=gender]').removeClass('error');
			validArray.push(true);
		} else {
			$('input[name=gender]').addClass('error');
			validArray.push(false);
		}
	};

	var openOverlay = function openOverlay(e) {
		e.preventDefault();

		$overlay.addClass('active');
		$shade.addClass('active');
		$('body').addClass('noscroll');
	};

	function checkTrue(con) {
		return con === true;
	}

	init();return api;
};

app.ext['header'] = function ($el) {
	var api = {};

	var $openable = $el.find('.openable');
	var $openableLink = $el.find('.openable > a');
	var $dropdown = $el.find('.header__dropdown');
	var $dropdownShade = $('.header__dropdown__shade');

	var hovering = false;
	var timeout = 0;

	var $menu = $('.header__navigation');

	var $logolink = $('.header__sony .logo');

	var $backlink = $('.header__sony .back');

	var registeredMobile = false;

	var $searchubtton = $el.find('.main-searchbutton');
	var $searchbar = $el.find('.js-search');

	var init = function init() {
		addEventHandlers();
		$(window).on('resize', addEventHandlers);
	};

	var addEventHandlers = function addEventHandlers() {
		if (window.innerWidth > 1023) {
			$openableLink.off('click', slideSubnav);
			$backlink.off('click');
			registeredMobile = false;

			$openable.on('mouseenter', openSubnav);
			$openable.on('mouseleave', resetHover);

			$dropdown.on('mouseenter', function () {
				hovering = true;
				startTimeout();
			});
			//$dropdown.on('mouseleave', resetHover)

			$menu.removeClass('transitionable');
		} else {
			if (!registeredMobile) {
				$openableLink.on('click', slideSubnav);
				$backlink.on('click', slideSubnav);
				registeredMobile = true;
			}
			$openable.off('mouseenter mouseleave');
			$dropdown.off('mouseenter mouseleave');

			$menu.addClass('transitionable');
		}

		$openableLink.on('click', function (e) {
			e.preventDefault();
		});
	};

	var openSubnav = function openSubnav(e) {
		e.preventDefault();
		hovering = true;

		$openable.removeClass('active');
		$dropdown.removeClass('active clickable');
		$dropdownShade.removeClass('active');

		var thisdropdown = $(this).find('.header__dropdown');
		thisdropdown.addClass('active clickable');
		$dropdownShade.addClass('active');
		$(this).addClass('active');

		if (timeout > 0) {
			clearTimeout(timeout);
		}

		//close search
		if ($searchubtton.hasClass('active')) {
			$searchbar.removeClass('active');
			$searchubtton.removeClass('active');
		}
	};

	var closeSubnav = function closeSubnav() {
		if (!hovering) {
			if (!$openable.hasClass('is-current')) {
				$openable.removeClass('active');
			}
			$dropdown.removeClass('active clickable');
			$dropdownShade.removeClass('active');
		}
	};

	var resetHover = function resetHover() {
		hovering = false;
		startTimeout();
	};

	var startTimeout = function startTimeout() {
		timeout = setTimeout(function () {
			closeSubnav();
		}, 300);
	};

	var slideSubnav = function slideSubnav(e) {
		e.preventDefault();
		var thisdropdown = $(this).parent().find('.header__dropdown');
		if ($dropdown.hasClass('active')) {
			$menu.removeClass('slideoutleft');
			$dropdown.removeClass('active');
			$backlink.removeClass('inscreen');
		} else {
			$menu.addClass('slideoutleft');
			thisdropdown.addClass('active');
			$backlink.addClass('inscreen');
		}
	};

	init();return api;
};

app.ext['heroslider'] = function ($el) {
	var api = {};

	var swiper = void 0;

	var init = function init() {
		swiper = new Swiper('.js-heroslider', {
			slidesPerView: 1,
			spaceBetween: 0,
			loop: true,
			speed: 700,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false
			},
			pagination: {
				el: '.js-heroslider-pagination',
				clickable: true
			},
			navigation: {
				nextEl: '.js-heroslider-next',
				prevEl: '.js-heroslider-prev'
			},
			on: {
				slideChangeTransitionStart: function slideChangeTransitionStart() {
					this.pagination.render();
					this.pagination.update();
				}
			}
		});
	};

	init();return api;
};

app.ext['htmlvideo'] = function ($el) {
	var api = {};

	var video = $el.find('video:visible').get(0);
	var $videoContainer = $el.find('.html-video__video');

	var $preview = $el.find('.html-video__preview');
	var $previewImage = $el.find('.html-video__preview__image');
	var $previewShade = $el.find('.html-video__preview__shade');

	var $playButton = $el.find('.html-video__preview__play');
	var $durationField = $el.find('.html-video__preview__duration');

	var videoLoaded = false;

	var $allVideos = $('video');

	var $video = $el.find('.video');

	var init = function init() {
		initVideo();
		addEventHandlers();
	};

	var addEventHandlers = function addEventHandlers() {
		$playButton.on('click', playVideo);

		$allVideos.on('play', function () {
			app.vars.activated = this;
			pauseOtherVideos();
		});
	};

	var playVideo = function playVideo() {

		video.load();

		var i = setInterval(function () {
			if (video.readyState > 0) {
				$preview.fadeOut(300);
				$previewImage.hide();
				$previewShade.hide();
				$durationField.hide();
				video.play();

				clearInterval(i);
			}
		}, 100);
	};

	var initVideo = function initVideo() {
		// add correct duration
		// let i = setInterval(function() {
		//     if(video.readyState > 0) {
		//         videoLoaded = true
		//         let minutes = parseInt(video.duration / 60, 10);
		//         let seconds = Math.round(video.duration % 60);

		//         $durationField.html(minutes + ":" + seconds + " min")

		//         clearInterval(i);
		//     }
		// }, 200);
	};

	var pauseOtherVideos = function pauseOtherVideos() {
		$allVideos.each(function () {
			if (this != app.vars.activated) this.pause();
		});
	};

	init();return api;
};

app.ext['informationtile'] = function ($el) {
	var api = {};

	var $container = $('.information-tiles');
	var $allTiles = $container.find('.js-informationtile');

	var $button = $el.find('a');

	var $image = $el.find('.information__image');

	var $overlay = $el.find('.information__overlay');

	var $close = $el.find('.information__overlay__close');

	var $shade = $image.find('.shade');

	var $contentWrapper = $el.find('.information__text__wrapper');

	var isOpen = false;

	var init = function init() {
		addEventHandlers();
	};

	var addEventHandlers = function addEventHandlers() {
		$el.on('click', expandTile);
		$close.on('click', shrinkTile);
		$shade.on('click', shrinkTile);
		$(document).on('click touchstart', closeTiles);
		$(window).resize(adjustMargin);
	};

	var expandTile = function expandTile(e) {
		var $clicked = $(this);
		//close open tiles
		if (!$clicked.find('.information__image').hasClass('opened')) {
			$allTiles.each(function () {
				if ($(this).find('.information__image').hasClass('opened')) {
					$(this).find('.information__overlay__close').trigger('click');
				}
			});
		}

		$image.addClass('opened');
		$el.addClass('no-delay').css({
			marginBottom: $overlay.outerHeight() + parseInt($overlay.css('top'), 10) - $el.outerHeight() + 100
		});
		isOpen = true;

		$overlay.removeClass('init-novisible').addClass('invisible');
		$overlay.addClass('come-down');
	};

	var shrinkTile = function shrinkTile(e) {
		e.preventDefault();
		e.stopPropagation();
		isOpen = false;

		$overlay.removeClass('come-down');

		$image.removeClass('opened');
		$el.css({ marginBottom: 40 });
		$overlay.addClass('init-novisible').removeClass('invisible');
	};

	var closeTiles = function closeTiles(e) {
		if (!$(e.target).closest('.information').length) {
			$allTiles.each(function () {
				if ($(this).find('.information__image').hasClass('opened')) {
					$(this).find('.information__overlay__close').trigger('click');
				}
			});
		}
	};

	var adjustMargin = function adjustMargin() {
		if (isOpen) {
			$el.removeClass('no-delay').css({
				marginBottom: $overlay.outerHeight() + parseInt($overlay.css('top'), 10) - $el.outerHeight() + 100
			});
		}
	};

	init();return api;
};

app.ext['loadmorenews'] = function ($el) {
	var api = {};

	var $hiddennews = $('.single-news.init-hidden, .large-news.init-hidden');

	var numberofnews = $hiddennews.length - 1;

	var showAtOnce = 6;

	var count = 0;

	var init = function init() {
		$el.on('click', loadnews);
	};

	var loadnews = function loadnews(e) {
		e.preventDefault();

		$hiddennews.each(function () {
			var $this = $(this);
			if (count === showAtOnce) {
				$hiddennews = $('.single-news.init-hidden, .large-news.init-hidden');
				count = 0;
				return false;
			}

			$this.removeClass('init-hidden').addClass('invisible');

			setTimeout(function () {
				$this.addClass('animate-in');
			}, 200 * count);

			if (numberofnews === 0) {
				$el.fadeOut(200);
			}
			numberofnews--;
			count++;
		});
	};

	init();return api;
};

app.ext['local-structure'] = function ($el) {
	var api = {};

	var init = function init() {};

	init();return api;
};

app.ext['locationfilter'] = function ($el) {
	var api = {};

	var $filterOptions = $el.find('.locations-list__filter ul li');

	var $countryBlocks = $el.find('.locations-list__countryblock');

	var slider = void 0;

	var init = function init() {
		addEventHandlers();
		initNavSwiper();
	};

	var addEventHandlers = function addEventHandlers() {
		$filterOptions.on('click', filterLocations);
	};

	var filterLocations = function filterLocations() {
		var $this = $(this);
		var id = $this.data('id');

		if (id === 0) {
			$countryBlocks.each(function () {
				$(this).show();
			});
		} else {
			$countryBlocks.each(function () {
				var $that = $(this);
				if ($that.data('continent') === id) {
					$that.show();
				} else {
					$that.hide();
				}
			});
		}

		$filterOptions.each(function () {
			$(this).removeClass('active');
		});
		$this.addClass('active');
	};

	var initNavSwiper = function initNavSwiper() {
		slider = new Swiper('.locations-list__filter', {
			slidesPerView: 'auto',
			simulateTouch: false,
			breakpoints: {
				768: {
					simulateTouch: true
				}
			}
		});
	};

	init();return api;
};

app.ext['map'] = function ($el) {
	var api = {};

	var init = function init() {
		addListeners();
		inView();

		noOverscroll();

		if (interactive) {
			mapInteractive();
		}
	};

	var data_url = $el.data('locations');

	var initialized;
	var interactive = $el.hasClass('map--interactive');
	var img_w;
	var img_h;
	var map_url = $el.data('url');
	var map_xy = app.vars.urlParam['map-xy'];
	var map_id = app.vars.urlParam['map-id'];
	var loc_arr = [];
	var groups = {};
	var zoomChanged;
	var touch;

	var $holder = $el.parents('.map-holder');
	var $section = $el.parents('.section');
	var $img = $('.map__img', $el);
	var $src = $('.map__src', $el);
	var $locations = $('.map__locations', $el);
	var $loc;
	var $loc_group;
	var $group = '<div class="map__loc map__loc--size-4 map__loc--color-0" data-id=""></div>';

	var $overlay = $('.map-overlay', $section);
	var $close = $('.map-overlay__close');
	var $filter = $('.map-filter', $section);
	var filterObj = {};
	var filterKeys = [];

	var createLocationString = function createLocationString(uptitle, title, description, address_title, address_body, postal_address_body, city, country, phone, mobile, email, fax, maps_link, information_link) {
		var string = '';
		string = '\n\t\t\t<div class="map-overlay__content">\n                    <div class="map-overlay__close"><span class="icon icon--close"></span></div>\n                    <div class="map-overlay__uptitle label label--small">\n                        ' + uptitle + '\n                    </div>\n                    <h2 class="map-overlay__title">\n                        ' + title + '\n                    </h2>\n                    <div class="map-overlay__description copy copy--small">\n                        ' + description + '\n                    </div>\n\n\t\t\t\t\t' + (address_title || address_body || postal_address_body || country ? '\n                    <div class="map-overlay__contactblock">\n                        <div class="map-overlay__contactblock__title">Address</div>\n                        <div class="map-overlay__contactblock__content">\n\t\t\t\t\t\t\t' + (address_title ? address_title + ' <br>' : '') + '\n\t\t\t\t\t\t\t' + (address_body ? address_body + ' <br>' : '') + '\n\t\t\t\t\t\t\t' + (postal_address_body ? postal_address_body + ' <br>' : '') + '\n\t\t\t\t\t\t\t' + (country ? country + ' <br>' : '') + '\n                        </div>\n                    </div>\n\t\t\t\t\t' : '') + '\n\n\t\t\t\t\t' + (phone || mobile || email || fax ? '\n                    <div class="map-overlay__contactblock">\n                        <div class="map-overlay__contactblock__title">Contact</div>\n\t\t\t\t\t\t<div class="map-overlay__contactblock__content">\n\n\t\t\t\t\t\t\t' + (phone ? '\n                            <div class="map-overlay__contactblock__row">\n                                <span class="type">Phone:</span>\n                                <a href="tel:' + phone + '">' + phone + '</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t' : '') + '\n\n\t\t\t\t\t\t\t' + (mobile ? '\n                            <div class="map-overlay__contactblock__row">\n                                <span class="type">Mobile:</span>\n                                <a href="tel:' + mobile + '">' + mobile + '</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t' : '') + '\n\n\t\t\t\t\t\t\t' + (email ? '\n                            <div class="map-overlay__contactblock__row">\n                                <span class="type">E-Mail:</span> \n                                <a href="mailto:' + email + '">' + email + '</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t' : '') + '\n\n\t\t\t\t\t\t\t' + (fax ? '\n                            <div class="map-overlay__contactblock__row">\n                                <span class="type">Fax:</span>\n                                <span>' + fax + '</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t' : '') + '\n                        </div>\n\t\t\t\t\t</div>\n\t\t\t\t\t' : '') + '\n\n\t\t\t\t\t' + (maps_link || information_link ? '\n\t\t\t\t\t<div class="map-overlay__linkblock">\n\n\t\t\t\t\t\t' + (maps_link ? '\n\t\t\t\t\t\t<a href="' + maps_link + '"><span>Driving directions</span><span class="icon icon--triangle-right"></span></a>\n\t\t\t\t\t\t' : '') + '\n\n\t\t\t\t\t\t' + (information_link ? '\n\t\t\t\t\t\t<a href="' + information_link + '"><span>More Information</span><span class="icon icon--triangle-right"></span></a>\n\t\t\t\t\t\t' : '') + '\n\t\t\t\t\t</div>\n\t\t\t\t\t' : '') + '\n\n                </div>\n\t\t\t';
		return string;
	};

	var noOverscroll = function noOverscroll() {
		$('body').css('overscroll-behavior', 'none');
	};

	var isTrue = function isTrue(e) {
		return e === true;
	};

	var mapSearch = function mapSearch() {
		jQuery.ajax({
			context: this,
			url: data_url,
			type: 'GET',
			data: {},
			dataType: 'json',
			contentType: 'application/json',
			cache: false,
			success: function success(data) {
				dataResponse(data.results[0]);
			}
		});
	};

	var mapSearchUpdate = function mapSearchUpdate(appliedFilter) {

		//filter locations
		$loc.each(function () {
			var $_l = $(this);
			if ($_l.data('loc_arr')) {
				var filterVals = [];
				for (var i in appliedFilter) {
					if (appliedFilter.hasOwnProperty(i)) {
						var val = appliedFilter[i] && $_l.data('loc_arr').filter[i];
						filterVals.push(val);
					}
				}

				if (filterVals.some(isTrue)
				//		(appliedFilter.sales && $_l.data('loc_arr').filter.sales) || 
				// 		(appliedFilter.production && $_l.data('loc_arr').filter.production) ||
				// 		(appliedFilter.distribution && $_l.data('loc_arr').filter.distribution) ||
				// 		(appliedFilter.new_media && $_l.data('loc_arr').filter.new_media) ||
				// 		(appliedFilter.engineering && $_l.data('loc_arr').filter.engineering) ||
				// 		(appliedFilter.service_center && $_l.data('loc_arr').filter.service_center)
				) {
						$_l.removeClass('map__loc--hidden').data('loc_arr').vis = true;
					} else {
					$_l.addClass('map__loc--hidden').data('loc_arr').vis = false;
				}
			}
		});

		// $('.map__loc:not(.map__group)').each(function() {
		// 	var $_l = $(this);
		// 	if ($_l.data('loc_arr')) $_l.addClass('map__loc--hidden').data('loc_arr').vis = false;
		// });

		zoomChanged = true;
		mapGroups();
	};

	$el.data('search-result-update', mapSearchUpdate);

	var mapLoad = function mapLoad() {
		mapSearch();
	};

	var mapFull = function mapFull() {
		$('.content').addClass('content--hasmap');
	};

	var mapInteractive = function mapInteractive() {
		$('body').on('mousewheel.smoothZoom', function (e) {
			if (!$('.overlay, .nav-main--open, .search--open').length) return false;
		});

		// FULLSCREEN
		mapFull();
		$(window).on('resize.map orientationchange.map', function () {
			mapFull();
		});

		var w = $img.outerWidth();
		var h = $img.outerHeight();
		var z = 100;
		var x = w / 2;
		var y = h / 2;

		if (map_xy) {
			var xy = map_xy.split(',');

			x = parseFloat(xy[0]) / 100 * w;
			y = parseFloat(xy[1]) / 100 * h;
		}

		if (navigator.userAgent.toLowerCase().match(/(android)/) && navigator.userAgent.toLowerCase().match(/(chrome)/)) {
			var _$img$smoothZoom;

			$img.smoothZoom((_$img$smoothZoom = {
				width: '100%',
				height: '100%',
				zoom_MIN: 60,
				zoom_MAX: 30500,
				zoom_OUT_TO_FIT: true,
				initial_ZOOM: 100,
				initial_POSITION: x + ',' + y,
				//image_original_width: '825px',
				//image_original_height: '430px',
				animation_SMOOTHNESS: touch ? 1.0 : 5.0,
				animation_SPEED_ZOOM: 5.0,
				animation_SPEED_PAN: 5.0,
				background_COLOR: 'transparent',
				border_SIZE: 0,
				border_COLOR: '#ffffff',
				border_TRANSPARENCY: 10,
				pan_BUTTONS_SHOW: 'NO',
				pan_LIMIT_BOUNDARY: 'NO',
				button_HOLDER: $holder,
				button_SIZE: 50,
				button_ICON_IMAGE: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
			}, _defineProperty(_$img$smoothZoom, 'pan_BUTTONS_SHOW', false), _defineProperty(_$img$smoothZoom, 'responsive', true), _defineProperty(_$img$smoothZoom, 'responsive_maintain_ratio', true), _defineProperty(_$img$smoothZoom, 'on_ZOOM_PAN_COMPLETE', zoomComplete), _defineProperty(_$img$smoothZoom, 'on_ZOOM_PAN_UPDATE', zoomUpdate), _defineProperty(_$img$smoothZoom, 'allow_PINCH_ZOOM', false), _$img$smoothZoom));
		} else {
			var _$img$smoothZoom2;

			//825 x 430
			$img.smoothZoom((_$img$smoothZoom2 = {
				width: '100%',
				height: '100%',
				zoom_MIN: 60,
				zoom_MAX: 30500,
				zoom_OUT_TO_FIT: true,
				initial_ZOOM: 100,
				initial_POSITION: x + ',' + y,
				//image_original_width: '825px',
				//image_original_height: '430px',
				animation_SMOOTHNESS: touch ? 1.0 : 5.0,
				animation_SPEED_ZOOM: 5.0,
				animation_SPEED_PAN: 5.0,
				background_COLOR: 'transparent',
				border_SIZE: 0,
				border_COLOR: '#ffffff',
				border_TRANSPARENCY: 10,
				pan_BUTTONS_SHOW: 'NO',
				pan_LIMIT_BOUNDARY: 'NO',
				button_HOLDER: $holder,
				button_SIZE: 50,
				button_ICON_IMAGE: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
			}, _defineProperty(_$img$smoothZoom2, 'pan_BUTTONS_SHOW', false), _defineProperty(_$img$smoothZoom2, 'responsive', true), _defineProperty(_$img$smoothZoom2, 'responsive_maintain_ratio', true), _defineProperty(_$img$smoothZoom2, 'on_ZOOM_PAN_COMPLETE', zoomComplete), _defineProperty(_$img$smoothZoom2, 'on_ZOOM_PAN_UPDATE', zoomUpdate), _$img$smoothZoom2));
		}

		if (map_xy) {
			//setTimeout(function(){
			var zoom = $img.smoothZoom('getZoomData');
			var sc = zoom.scaledHeight / zoom.normHeight;

			$img.smoothZoom('focusTo', {
				x: parseFloat(xy[0]) / 100 * w,
				y: parseFloat(xy[1]) / 100 * h,
				zoom: 100 * sc * 2,
				//zoom: 300,
				speed: 5
			});
			//}, 100);
		}

		mapUpdate();

		$section.addClass('section--map-show');
	};

	var zoomActive,
	    zoomTimer,
	    zoomInt = false,
	    zoomData,
	    zoomScale,
	    zoomX,
	    zoomY;
	var zoomUpdate = function zoomUpdate() {
		zoomActive = true;
		zoomChanged = true;
		zoomData = $img.smoothZoom('getZoomData');

		/*if(!zoomInt){
  	zoomInt = setInterval(function(){
  		clearTimeout(zoomTimer);
  			zoomTimer = setTimeout(function(){
  			mapGroups();
  		}, 0);
  	}, 200);
  }*/
	};
	var zoomComplete = function zoomComplete() {
		zoomActive = false;
		clearInterval(zoomInt);
		zoomInt = false;
		mapGroups();
	};

	var mapUpdate = function mapUpdate() {

		requestAnimationFrame(mapUpdate);

		if (zoomData && (zoomScale != zoomData.scaledWidth || zoomX != zoomData.scaledX || zoomY != zoomData.scaledY || img_w != $img.outerWidth())) {
			var trans;
			//var matrix = $img.panzoom('getMatrix');
			var m = $img.css('transform');
			var img_resized = img_w != $img.outerWidth();

			//console.log('img_resized:'+img_resized);

			img_w = $img.outerWidth();

			if (!touch) {
				if (zoomScale != zoomData.scaledWidth || img_resized) {
					/*clearTimeout(zoomTimer);
     zoomTimer = setTimeout(function(){
     	mapGroups();
     }, 100);*/
					if (!zoomInt && zoomActive || img_resized) {
						//console.log('zoomInt');

						if (img_resized) {
							clearTimeout(zoomTimer);
							zoomTimer = setTimeout(function () {
								mapGroups();
							}, 0);
						} else {
							zoomInt = setInterval(function () {
								clearTimeout(zoomTimer);
								zoomTimer = setTimeout(function () {
									mapGroups();
								}, 0);
							}, 500);
						}
					}
				}
			}

			if (zoomScale != zoomData.scaledWidth) {
				var scale = m.split('(')[1].split(',')[0];
				zoomScale = zoomData.scaledWidth;
				trans = true;

				$locations.css('width', scale * 100 + '%');
				$locations.css('height', scale * 100 + '%');
			}
			if (zoomX != zoomData.scaledX || zoomY != zoomData.scaledY) {
				var pos = $img.position();
				zoomX = zoomData.scaledX;
				zoomY = zoomData.scaledY;
				trans = true;

				$locations.css('left', pos.left + 'px');
				$locations.css('top', pos.top + 'px');
			}
			if (trans) {
				//$locations.css('transform', 'matrix('+scale+',0,0,'+scale+','+mx.m41+','+mx.m42+')');
				$src.css('transform', m);
			}
		}
	};

	var distance = function distance(l, lc) {
		var distX = lc.x - l.x;
		var distY = lc.y - l.y;
		var dist = Math.sqrt(distX * distX + distY * distY);
		return dist;
	};

	var mapGroupPos = function mapGroupPos(g, l) {
		if (g.x_max < l.x) {
			g.x_max = l.x;
		}
		if (g.x_min > l.x) {
			g.x_min = l.x;
		}
		if (g.y_max < l.y) {
			g.y_max = l.y;
		}
		if (g.y_min > l.y) {
			g.y_min = l.y;
		}
	};

	var mapGroups = function mapGroups() {
		var min = 30;

		//console.log('mapGroups');

		if (interactive && $loc && zoomChanged) {
			zoomChanged = false;

			$loc.removeClass('map__loc--group');
			if ($loc_group) $loc_group.removeClass('map__group--show');

			var loc_w = $locations.outerWidth();
			//var loc_list	= JSON.parse(JSON.stringify(loc_arr));
			var loc_list = clone(loc_arr);
			var cnt = 0;

			groups = {};

			for (var i = 0; i < loc_arr.length; i++) {
				var l = loc_list.shift();

				if (l.vis == true) {

					for (var c = 0; c < loc_list.length; c++) {
						var lc = loc_list[c];
						var dist = loc_w / 100 * distance(l, lc);

						if (dist < min && lc.vis == true) {
							//var $l = $('.map__loc:eq('+l.i+')', $locations);
							//var $lc = $('.map__loc:eq('+lc.i+')', $locations);
							//var g = groups['g'+l.i] || groups['g'+lc.i];
							var g = l.group || lc.group;

							//console.log(l);
							//console.log(lc);
							//console.log(g);
							//console.log(l.title+' | '+lc.title);
							//console.log(l.group+' | '+lc.group);

							if (!g) {
								g = l.group = lc.group = groups['g' + l.i] = { i: l.i, group: [l, lc], x_min: 101, y_min: 101, x_max: -1, y_max: -1 };

								mapGroupPos(g, l);
								mapGroupPos(g, lc);

								if (!$('.map__group.g' + l.i, $locations).length) {
									var $group = $('<div class="map__loc map__loc--size-4 map__group g' + l.i + '"><div class="map__loc__nr"></div></div>');
									$locations.append($group);
									$loc_group = $('.map__group', $locations);

									mouseOverListener($group);
								}
							} else {
								if (l.group && lc.group) {
									//console.log('-- DOUBLE --');
									while (function () {
										return l.group.group.length;
									} > 0) {
										lc.group.group.push(l.group.group.shift());
									}
									delete groups['g' + l.i];
								} else {
									g.group.push(l.group ? lc : l);
									l.group = lc.group = l.group || lc.group;
									mapGroupPos(g, l.group ? lc : l);
								}
							}

							var $g = $('.map__group.g' + g.i, $locations);
							var x = g.x_min + (g.x_max - g.x_min) / 2;
							var y = g.y_min + (g.y_max - g.y_min) / 2;

							$g.css('left', x + '%').css('top', y + '%').addClass('map__group--show');
							$('.map__loc__nr', $g).text(g.group.length);
							$('.map__loc:eq(' + l.i + '), .map__loc:eq(' + lc.i + ')', $locations).addClass('map__loc--group');
						}

						cnt++;
					}
				}
			}
			//console.log(groups);
			//console.log(cnt);
		}
		//setTimeout(mapGroups, 250);
	};

	var mapAddress = function mapAddress($l) {
		var locs = $l.data('loc');
		var loc_arr = $l.data('loc_arr');

		for (var i = 0; i < locs.length; i++) {
			var loc = locs[i];
			var locationString = createLocationString(loc.uptitle, loc.title, loc.description, loc.address_title, loc.address_body, loc.postal_address_body, loc.city, loc.country, loc.phone, loc.mobile, loc.email, loc.fax, loc.maps_link, loc.information_link);
			$overlay.addClass('active').fadeIn().empty().append(locationString);
		}

		$('.map-holder>[class*=noSel]').addClass('almostinvisible');
	};

	var dataResponse = function dataResponse(data) {
		//console.log(data);
		if (data && data.hits) {
			var locations = data.hits;
			var loc_arr_parent = [];
			var cnt = 0;

			//get filter keys and create filter object
			filterKeys = Object.keys(locations[0].filter);
			filterKeys.forEach(function (el, i) {
				filterObj[el] = true;
			});

			for (var i = 0; i < locations.length; i++) {
				var loc = locations[i];
				var show = interactive && loc.visible_in_map || !interactive && loc.visible_in_teaser;

				if (!interactive && show || interactive) {
					var pos = convertGeoToPixel(loc.coordinates.lat, loc.coordinates.lng);
					var size = 1;
					var color = loc.company.length > 1 || loc.company[0] == 'Borealis' ? 0 : loc.company[0] == 'Borouge' ? 1 : 2;
					var id = loc.objectID;
					var title = loc.group_title;
					var addr = loc.title ? '<div class="map__loc__addr"><p>' + title + '</p></div>' : '';
					var $l = $('<div class="map__loc map__loc--size-' + size + ' map__loc--color-' + color + '" data-id="' + id + '" style="left: ' + pos.x + '%; top: ' + pos.y + '%;">' + addr + '</div>');
					var filter = loc.filter;
					var obj = {
						l: $l,
						i: cnt,
						x: parseFloat(pos.x),
						y: parseFloat(pos.y),
						size: size,
						color: color,
						title: title,
						addr: addr,
						loc: loc,
						vis: true,
						filter: filter
					};

					$l.data('loc', [loc]).data('loc_arr', obj);

					if (loc.parent == false) {
						loc_arr.push(obj);
						cnt++;

						// APPEND ITEM
						$locations.append($l);
					} else {
						loc_arr_parent.push(obj);
					}
				}
			}

			loc_arr_parent.sort(function (a, b) {
				return String(a.loc.position).localeCompare(b.loc.position);
			});

			for (var i = 0; i < loc_arr_parent.length; i++) {
				var obj = loc_arr_parent[i];
				var $parent = $('[data-id="' + obj.loc.parent + '"]', $locations);
				//console.log($parent);
				if ($('p', $parent).text().indexOf(obj.loc.group_title) < 0) {
					$('p', $parent).html($('p', $parent).html() + '<br>' + obj.loc.group_title);
				}
				$parent.data('loc').push(obj.loc);
			}

			// MOUSE EVENTS
			$loc = $('.map__loc', $locations);
			//$el.append('<div class="map__hover"></div>');

			mouseOverListener($loc);

			// SHOW
			setTimeout(function () {
				$el.addClass('map--show');
				mapGroups();
			}, 100);

			if (interactive && map_id) {
				setTimeout(function () {
					locClick($('.map__loc[data-id="' + map_id + '"]', $locations));
					map_id = false;
				}, 800);
			}
		}
	};

	var convertGeoToPixel = function convertGeoToPixel(latitude, longitude) {
		var mapWidth = 615.3; // in pixels
		var mapHeight = 394.1; // in pixels
		var mapLngLeft = -171.841723; // in degrees. the longitude of the left side of the map (i.e. the longitude of whatever is depicted on the left-most part of the map image)
		//var mapLngRight	= -169.653160;
		//var mapLngRight		= 190.34684; // in degrees. the longitude of the right side of the map
		var mapLngRight = 189.8;
		//var mapLatBottom	= -55.98; // in degrees.  the latitude of the bottom of the map
		var mapLatBottom = -55.15;

		var mapLatBottomRad = mapLatBottom * Math.PI / 180;
		var latitudeRad = latitude * Math.PI / 180;
		var mapLngDelta = mapLngRight - mapLngLeft;

		var worldMapWidth = mapWidth / mapLngDelta * 360 / (2 * Math.PI);
		var mapOffsetY = worldMapWidth / 2 * Math.log((1 + Math.sin(mapLatBottomRad)) / (1 - Math.sin(mapLatBottomRad)));

		var x = (longitude - mapLngLeft) * (mapWidth / mapLngDelta);
		var y = mapHeight - (worldMapWidth / 2 * Math.log((1 + Math.sin(latitudeRad)) / (1 - Math.sin(latitudeRad))) - mapOffsetY);

		var xp = x * 100 / mapWidth;
		var yp = y * 100 / mapHeight;

		//console.log(xp+' | '+yp);

		return { x: xp, y: yp };
	};

	window.doubleClick = 0;
	var mouseOverListener = function mouseOverListener($item) {
		$item.on('pointerover mouseover', function (e) {
			var $target = $(e.currentTarget);
			$el.addClass('map--hover');
			$target.addClass('map__loc--hover');
		}).on('pointerout mouseout', function (e) {
			var $target = $(e.currentTarget);
			$el.removeClass('map--hover');
			$target.removeClass('map__loc--hover');
		});

		$item.on('click', function (e) {
			var $target = $(e.currentTarget);
			locClick($target);
		});
	};

	var locClick = function locClick($target) {
		if (interactive) {
			window.doubleClick++;

			if (window.doubleClick < 2) {
				var pos = $target.position();
				var is_group = $target.hasClass('map__group');

				$el.removeClass('map--hover');
				$target.removeClass('map__loc--hover');

				var zoom = $img.smoothZoom('getZoomData');
				var sc = zoom.scaledHeight / zoom.normHeight;

				$img.smoothZoom('focusTo', {
					x: pos.left / sc,
					y: pos.top / sc,
					zoom: is_group ? 100 * sc * 4 : 100 * sc,
					//zoom: 300,
					speed: touch ? 0 : 5
				});

				if (!is_group) {
					mapAddress($target);
				}
				setTimeout(function () {
					window.doubleClick = 0;
				}, 500);
			} else {
				console.log('DOUBLE');
			}
		} else {
			var loc = $target.data('loc')[0];
			var xy = convertGeoToPixel(loc.coordinates.lat, loc.coordinates.lng);
			var url = '?map-xy=' + xy.x + ',' + xy.y;
			//console.log(xy);
			if (loc.is_group != true) {
				url += '&map-id=' + loc.objectID;
			}
			window.location = map_url + url;
		}
	};

	var addListeners = function addListeners() {
		$(window).on('scroll.map', function () {
			inView();
		});

		$(document).on('click', '.map-overlay__close', function () {
			$overlay.fadeOut().removeClass('active');
			$('.map-holder>[class*=noSel]').removeClass('almostinvisible');
		});

		$overlay.on('click', function (e) {
			if ($(e.target).is('.map-overlay')) {
				$overlay.fadeOut().removeClass('active');
				$('.map-holder>[class*=noSel]').removeClass('almostinvisible');
			}
		});

		$filter.on('click', '.map-filter__title', function () {
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$filter.find('.map-filter__content').stop().slideUp();
			} else {
				$(this).addClass('active');
				$filter.find('.map-filter__content').stop().slideDown();
			}
		});

		$filter.on('change', 'input[type=checkbox]', function (e) {
			var filterPlace = this.id;
			var isChecked = this.checked;

			filterObj[filterPlace] = isChecked;

			console.log(filterObj);

			mapSearchUpdate(filterObj);
		});

		// $projects_inner.on('click', function(e) {
		// 	if (!$(e.target).is('a.learn-read-more')) {
		// 		e.preventDefault();
		// 		e.stopPropagation();
		// 	}
		// })
	};

	var inView = function inView(e) {
		touch = $('html').hasClass('screen--is-touch');
		if (isVisible($el) && ($el.parents('.is-hidden.open, .teaser-map').length || interactive)) {
			if (!initialized) {
				initialized = true;
				$(window).off('scroll.map');
				mapLoad();
			}
		}
	};

	var isVisible = function isVisible($e) {
		var rect = $e[0].getBoundingClientRect();
		return (rect.height > 0 || rect.width > 0) && rect.bottom >= 0 && rect.right >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.left <= (window.innerWidth || document.documentElement.clientWidth);
	};

	var clone = function clone(src) {
		function mixin(dest, source, copyFunc) {
			var name,
			    s,
			    i,
			    empty = {};
			for (name in source) {
				// the (!(name in empty) || empty[name] !== s) condition avoids copying properties in "source"
				// inherited from Object.prototype.	 For example, if dest has a custom toString() method,
				// don't overwrite it with the toString() method that source inherited from Object.prototype
				s = source[name];
				if (!(name in dest) || dest[name] !== s && (!(name in empty) || empty[name] !== s)) {
					dest[name] = copyFunc ? copyFunc(s) : s;
				}
			}
			return dest;
		}

		if (!src || (typeof src === 'undefined' ? 'undefined' : _typeof(src)) != "object" || Object.prototype.toString.call(src) === "[object Function]") {
			// null, undefined, any non-object, or function
			return src; // anything
		}
		if (src.nodeType && "cloneNode" in src) {
			// DOM Node
			return src.cloneNode(true); // Node
		}
		if (src instanceof Date) {
			// Date
			return new Date(src.getTime()); // Date
		}
		if (src instanceof RegExp) {
			// RegExp
			return new RegExp(src); // RegExp
		}
		var r, i, l;
		if (src instanceof Array) {
			// array
			r = [];
			for (i = 0, l = src.length; i < l; ++i) {
				if (i in src) {
					r.push(clone(src[i]));
				}
			}
			// we don't clone functions for performance reasons
			//		}else if(d.isFunction(src)){
			//			// function
			//			r = function(){ return src.apply(this, arguments); };
		} else {
			// generic objects
			r = src.constructor ? new src.constructor() : {};
		}
		return mixin(r, src, clone);
	};

	init();return api;
};

app.ext['overlay'] = function ($el) {
	var api = {};

	var $close = $el.find('.overlay__close');

	var $shade = $('.overlayshade');

	var init = function init() {
		addEventHandlers();
	};

	var addEventHandlers = function addEventHandlers() {
		$close.on('click', closeOverlay);
		$shade.on('click', closeOverlay);
	};

	var closeOverlay = function closeOverlay() {
		var margintop = parseInt($('body').data('tops'));

		//$el.removeClass('active')
		$el.animate({ marginRight: -$el.outerWidth() }, {
			duration: 300,
			complete: function complete() {
				$(this).removeAttr('style');
			}
		});
		$shade.removeClass('active');
		$('body').removeClass('noscroll').removeAttr('style');

		if ($el.hasClass('overlay--callback')) {
			$('html, body').animate({
				scrollTop: margintop
			}, 0);
		}

		setTimeout(function () {
			$el.animate({
				scrollTop: 0
			}, 0);
		}, 500);
	};

	init();return api;
};

app.ext['productslider'] = function ($el) {
	var api = {};

	var swiper = void 0;

	var init = function init() {
		swiper = new Swiper('.js-productslider.swiper-container', {
			slidesPerView: 'auto',
			spaceBetween: 20,
			loop: false,
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			on: {
				slideChangeTransitionStart: function slideChangeTransitionStart() {
					this.pagination.render();
					this.pagination.update();
				}
			}
		});
	};

	init();return api;
};

app.ext['scrollup'] = function ($el) {
	var api = {};

	var init = function init() {
		$el.on('click', scrollToTop);
	};

	var scrollToTop = function scrollToTop() {
		$("html, body").animate({ scrollTop: 0 }, 600);
	};

	init();return api;
};

app.ext['search'] = function ($el) {
	var api = {};

	var $searchubtton = $el.siblings('.main-searchbutton');

	var $searchbar = $el;

	var $input = $searchbar.find('input[type=text]');

	var $suggestions = $searchbar.find('.header__searchsuggestions');

	var $dropdownShade = $('.header__dropdown__shade');

	var init = function init() {
		addEventHandlers();
	};

	var addEventHandlers = function addEventHandlers() {
		$searchubtton.on('click', toggleSearch);
		$input.on('input', showSuggestions);
		$input.on('blur', function () {
			$suggestions.stop().slideUp(200);
		});
		$('.header, .header__dropdown__shade').on('click', function (e) {
			if (!$(e.target).closest('a').length && !$(e.target).hasClass('header__searchbutton') && $searchubtton.hasClass('active') && !$(e.target).closest('.header__searchdropdown').length) {
				$searchbar.removeClass('active');
				$searchubtton.removeClass('active');
				$dropdownShade.removeClass('active');
			}
		});
	};

	var toggleSearch = function toggleSearch(e) {
		if ($('.content').hasClass('content--searchresults')) {
			return false;
		}

		if ($searchubtton.hasClass('active')) {
			$searchbar.removeClass('active');
			$searchubtton.removeClass('active');
			$dropdownShade.removeClass('active');
		} else {
			$searchbar.addClass('active');
			$searchubtton.addClass('active');
			$input.focus();
			$dropdownShade.addClass('active');
		}
	};

	var showSuggestions = function showSuggestions() {
		if ($input.val() !== '') {
			$suggestions.stop().slideDown(200);
		} else {
			$suggestions.stop().slideUp(200);
		}
	};

	init();return api;
};

app.ext['solutions'] = function ($el) {
	var api = {};

	var $solution_fields = $el.find('.solutions__field');

	var init = function init() {
		$solution_fields.on('mouseenter', fadeImageIn);
		$solution_fields.on('mouseleave', fadeImageOut);
	};

	var fadeImageIn = function fadeImageIn() {
		var $this = $(this);

		var selector = $this.data('selector');

		var $matching_image = $el.find('.solutions__image[data-selector="' + selector + '"]');

		$matching_image.css('opacity', '1');
	};

	var fadeImageOut = function fadeImageOut() {
		var $this = $(this);

		var selector = $this.data('selector');

		var $matching_image = $el.find('.solutions__image[data-selector="' + selector + '"]');

		$matching_image.css('opacity', '0');
	};

	init();return api;
};

app.ext['solutionsslider'] = function ($el) {
	var api = {};

	var swiper = void 0;

	var init = function init() {
		swiper = new Swiper('.js-solutionsslider.swiper-container', {
			slidesPerView: 1,
			spaceBetween: 40,
			loop: false,
			centeredSlides: false,
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			on: {
				slideChangeTransitionStart: function slideChangeTransitionStart() {
					this.pagination.render();
					this.pagination.update();
				}
			}
		});
	};

	init();return api;
};

app.ext['subnavigation'] = function ($el) {
	var api = {};

	//let offsetTop = $el.offset().top

	var menuHeight = $('.header').outerHeight();

	var offsetTop = $('.hero').first().outerHeight() + menuHeight;

	var $header = $('.header');
	var $dropdown = $('.header__dropdown');
	var $dropdownShade = $('.header__dropdown__shade');

	var contentDifference = offsetTop - menuHeight;

	var scrollPosition = $(window).scrollTop();

	var subnavHeight = $el.outerHeight(true);

	var $hero = $('.hero');

	var slider = void 0;

	var positionForBurgernav = offsetTop - scrollPosition;

	var $headerNavigation = $('.header__navigation');

	var init = function init() {
		moveMenus();
		initSlider();

		$(window).on('scroll resize', moveMenus);
	};

	var moveMenus = function moveMenus(e) {

		scrollPosition = $(window).scrollTop();

		positionForBurgernav = offsetTop - scrollPosition;

		menuHeight = $('.header').outerHeight();

		offsetTop = $('.hero').first().outerHeight() + menuHeight;

		// if (scrollPosition >= contentDifference) {
		//     // $header.css({
		//     //     position: 'absolute',
		//     //     top: contentDifference
		//     // })

		//     if (window.innerWidth < 1024) {
		//         $headerNavigation.css({
		//             top: positionForBurgernav,
		//             height: 'calc(100% - ' + positionForBurgernav+ 'px)'
		//         })
		//     } else {
		//         $headerNavigation.removeAttr( 'style' )
		//         $dropdown.removeClass('active clickable')
		//         $dropdownShade.removeClass('active')
		//     }
		// } else {
		//     $headerNavigation.removeAttr( 'style' )
		//     $header.css({
		//         position: 'fixed',
		//         top: 0
		//     })
		// }

		if (scrollPosition >= offsetTop - menuHeight) {
			$el.css({
				position: 'fixed',
				top: menuHeight,
				right: 0,
				left: 0,
				zIndex: 1500
			});
			$hero.css({
				marginBottom: subnavHeight
			});
		} else {
			$el.css({
				position: 'relative',
				top: 0,
				right: 0,
				left: 0,
				zIndex: 1500
			});
			$hero.css({
				marginBottom: 0
			});
		}
	};

	var initSlider = function initSlider() {
		slider = new Swiper('.lowernav', {
			slidesPerView: 'auto',
			freeMode: true
		});
	};

	init();return api;
};

app.ext['supplychain'] = function ($el) {
	var api = {};

	var isTouch = Modernizr.touch;

	var baseColor = '#f1f5f9';
	var hoverColor = '#406eec';

	var animationTime = 200;

	var s = Snap('#supply-svg');
	var customers = s.select('#customers');
	var planning = s.select('#planning');
	var execution = s.select('#execution');
	var delivery = s.select('#delivery');
	var services = s.select('#services');
	var figures = s.select('#figures');

	// base point attr
	var customersBaseShape = $('#customers').attr('points');
	var planningBaseShape = $('#planning').attr('points');
	var executionBaseShape = $('#execution').attr('points');
	var deliveryBaseShape = $('#delivery').attr('points');
	var figuresBaseShape = $('#figures').attr('points');

	var swiper = void 0;

	var swiperProgressIndicator = $('.supply-chain__swiperprogress__indicator');

	var executable = 'animate';

	var init = function init() {
		//remove animation in ie and edge
		if (Detectizr.browser.name == 'edge' || Detectizr.browser.name == 'ie') {
			executable = 'attr';
		}

		initSwiper();
		initD2cHover();

		if (isTouch) {
			initClickHandlers();
		} else {
			initCustomersHover();
			initPlanningHover();
			initExecutionHover();
			initDeliveryHover();
			initServicesHover();
			initFiguresHover();

			initDraggable();

			initClickHandlers();
		}

		$(window).on('resize', function () {
			deactivateAll();
			backToBase();
		});
	};

	var initCustomersHover = function initCustomersHover() {
		$('#customers').on('mouseleave', function () {
			backToBase();
			deactivateCustomers();
		});

		//mouseover
		$('#customers').on('mouseenter', function () {
			allMouseOut();
			activateCustomers();
		});
	};

	var initPlanningHover = function initPlanningHover() {
		$('#planning').on('mouseleave', function () {
			backToBase();

			deactivatePlanning();
		});

		//mouseover
		$('#planning').on('mouseenter', function () {
			allMouseOut();

			activatePlanning();
		});
	};

	var initExecutionHover = function initExecutionHover() {
		$('#execution').on('mouseleave', function () {
			backToBase();
			deactivateExecution();
		});

		$('#execution').on('mouseenter', function () {
			allMouseOut();

			activateExecution();
		});
	};

	var initDeliveryHover = function initDeliveryHover() {
		$('#delivery, .delivery-triple').on('mouseleave', function () {
			backToBase();
			deactivateDelivery();
		});

		$('#delivery, .delivery-triple').on('mouseenter', function () {
			allMouseOut();

			activateDelivery();
		});
	};

	var initFiguresHover = function initFiguresHover() {
		$('#figures').on('mouseleave', function () {
			backToBase();
			$('.figures-text').removeClass('active');
		});

		$('#figures').on('mouseenter', function () {
			allMouseOut();

			activateFigures();
		});
	};

	var initServicesHover = function initServicesHover() {
		$('#services').on('mouseleave', function () {
			backToBase();
			$('.services-text').removeClass('active');
		});

		$('#services').on('mouseenter', function () {
			allMouseOut();

			activateServices();
		});
	};

	var initClickHandlers = function initClickHandlers() {
		$('#customers').on('click', function () {
			backToBase();
			deactivateAll();
			if ($('.customers-text').hasClass('active')) {
				deactivateCustomers();
			} else {
				activateCustomers();
				if (window.innerWidth < 1024) {
					slideToLeft();
				}
			}
		});

		$('#planning').on('click', function () {
			backToBase();
			deactivateAll();
			if ($('.planning-text').hasClass('active')) {
				deactivatePlanning();
			} else {
				activatePlanning();
				if (window.innerWidth < 1024) {
					slideToSecond();
				}
			}
		});

		$('#execution').on('click', function () {
			backToBase();
			deactivateAll();
			if ($('.execution-text').hasClass('active')) {
				deactivateExecution();
			} else {
				activateExecution();
				if (window.innerWidth < 1024) {
					slideToThird();
				}
			}
		});

		$('#delivery, .delivery-triple').on('click', function () {
			backToBase();
			deactivateAll();
			if ($('.delivery-triple').hasClass('active')) {
				deactivateDelivery();
			} else {
				activateDelivery();
				if (window.innerWidth < 1024) {
					slideToRight();
				}
			}
		});

		$('#figures').on('click', function () {
			backToBase();
			deactivateAll();
			if ($('.figures-text').hasClass('active')) {
				$('.figures-text').removeClass('active');
			} else {
				activateFigures();
				if (window.innerWidth < 1024) {
					slideToCenter();
				}
			}
		});

		$('#services').on('click', function () {
			backToBase();
			deactivateAll();
			if ($('.services-text').hasClass('active')) {
				$('.services-text').removeClass('active');
			} else {
				activateServices();
				if (window.innerWidth < 1024) {
					slideToCenter();
				}
			}
		});
	};

	var slideToLeft = function slideToLeft() {
		swiper.setTranslate(0);
	};

	var slideToRight = function slideToRight() {
		var maxTranslate = $('.supply-chain__slide').outerWidth() - swiper.width;
		swiper.setTranslate(-maxTranslate);
	};

	var slideToCenter = function slideToCenter() {
		var halfTranslate = ($('.supply-chain__slide').outerWidth() - swiper.width) / 2 - 10;
		swiper.setTranslate(-halfTranslate);
	};

	var slideToSecond = function slideToSecond() {
		var maxTranslate = $('.supply-chain__slide').outerWidth() - swiper.width;
		var secondTranslate = maxTranslate / 8 * 3 - 10;
		swiper.setTranslate(-secondTranslate);
	};

	var slideToThird = function slideToThird() {
		var maxTranslate = $('.supply-chain__slide').outerWidth() - swiper.width;
		var thirdTranslate = maxTranslate / 8 * 5 + 20;
		swiper.setTranslate(-thirdTranslate);
	};

	var backToBase = function backToBase() {
		customers[executable]({
			fill: baseColor,
			opacity: 0.13,
			points: customersBaseShape
		}, animationTime);
		planning[executable]({
			fill: baseColor,
			opacity: 0.13,
			points: planningBaseShape
		}, animationTime);
		execution[executable]({
			fill: baseColor,
			opacity: 0.13,
			points: executionBaseShape
		}, animationTime);
		delivery[executable]({
			fill: baseColor,
			opacity: 0.13,
			points: deliveryBaseShape
		}, animationTime);
		figures[executable]({
			fill: baseColor,
			opacity: 0.13,
			points: figuresBaseShape
		}, animationTime);
		services[executable]({
			fill: baseColor,
			opacity: 0.13
		}, animationTime);
	};

	var initSwiper = function initSwiper() {
		swiper = new Swiper('.supply-chain__swiper', {
			freeMode: true,
			freeModeMomentum: false,
			slidesPerView: 'auto',
			slidesOffsetAfter: 1,
			simulateTouch: false,
			speed: 200,
			breakpoints: {
				1280: {
					grabCursor: true,
					simulateTouch: true
				}
			},
			on: {
				progress: function progress() {
					if (window.innerWidth < 1024 && !$('.services-text').hasClass('active') && !$('.figures-text').hasClass('active')) {
						if (this.progress >= 0 && this.progress <= 1) {
							swiperProgressIndicator.css({
								left: this.progress * 100 + '%'
							});
						}

						if (this.progress <= 0.25) {
							backToBase();
							deactivateAll();

							activateCustomers();
						}

						if (this.progress > 0.25 && this.progress <= 0.5) {
							backToBase();
							deactivateAll();

							activatePlanning();
						}

						if (this.progress > 0.5 && this.progress <= 0.75) {
							backToBase();
							deactivateAll();

							$('.delivery-triple__text').removeClass('active');

							activateExecution();
						}

						if (this.progress > 0.75) {
							backToBase();
							deactivateAll();
							activateDelivery();
						}
					}
				}
			}
		});
	};

	var initDraggable = function initDraggable() {
		swiperProgressIndicator.draggable({
			containment: "parent",
			axis: "x",
			drag: function drag() {
				var leftPercentage = 100 * parseFloat($(this).position().left / parseFloat($(this).parent().outerWidth()));
				var maxTranslate = $('.supply-chain__slide').outerWidth() - swiper.width;
				var translate = leftPercentage * maxTranslate / 100 + 30;
				swiper.setTranslate(-translate);
			}
		});
	};

	var initD2cHover = function initD2cHover() {
		$('.delivery-triple__headline').on('mouseenter', function () {
			$(this).siblings('.delivery-triple__text').addClass('active');
			$('#delivery').trigger('click');
		});

		$('.delivery-triple__content').on('mouseleave', function (e) {
			$(this).find('.delivery-triple__text').removeClass('active');
		});
	};

	var allMouseOut = function allMouseOut() {
		$('#customers').mouseleave();
		$('#planning').mouseleave();
		$('#execution').mouseleave();
		$('#services').mouseleave();
		$('#figures').mouseleave();
		$('#delivery, .delivery-triple').mouseleave();
	};

	var deactivateAll = function deactivateAll() {
		deactivateCustomers();
		deactivatePlanning();
		deactivateExecution();
		deactivateDelivery();
		$('.services-text').removeClass('active');
		$('.figures-text').removeClass('active');
	};

	var activateCustomers = function activateCustomers() {
		customers[executable]({
			fill: hoverColor,
			opacity: 1,
			points: '383,0 413,250 383,500 0,500 0,0'
		}, animationTime);

		planning[executable]({
			points: '399.56,387 416,250 386,0 709.505,0 739.505,250 719.465,387'
		}, animationTime);

		execution[executable]({
			points: '722.46,387 742.5,250 712.5,0 1046,0 1076.01,250 1059.513,387'
		}, animationTime);

		delivery[executable]({
			points: '1382.515,500 1049,500 1079,250 1049,0 1382.515,0 1412.515,250'
		}, animationTime);

		figures[executable]({
			points: '399.31,390 1059.1,390 1046,500 386,500'
		}, animationTime);

		$('.customers-text').addClass('active');

		$('.planning-text').addClass('toright');
		$('.execution-text').addClass('toright');
		$('.figures-text').addClass('toright');
	};

	var deactivateCustomers = function deactivateCustomers() {
		$('.customers-text').removeClass('active');

		$('.planning-text').removeClass('toright');
		$('.execution-text').removeClass('toright');
		$('.figures-text').removeClass('toright');
	};

	var activatePlanning = function activatePlanning() {
		planning[executable]({
			fill: hoverColor,
			opacity: 1,
			points: '349.56,387 366,250 336,0 719.505,0 749.505,250 729.465,387'
		}, animationTime);

		customers[executable]({
			points: '333,0 363,250 333,500 0,500 0,0'
		}, animationTime);

		execution[executable]({
			points: '732.46,387 752.5,250 722.5,0 1056,0 1086.01,250 1069.513,387'
		}, animationTime);

		delivery[executable]({
			points: '1382.515,500 1059,500 1089,250 1059,0 1382.515,0 1412.515,250'
		}, animationTime);

		figures[executable]({
			points: '349.31,390 1069.1,390 1056,500 336,500'
		}, animationTime);

		$('.planning-text').addClass('active');

		$('#execution-headline').addClass('toright');
	};

	var deactivatePlanning = function deactivatePlanning() {
		$('.planning-text').removeClass('active');
		$('#execution-headline').removeClass('toright');
	};

	var activateExecution = function activateExecution() {
		execution[executable]({
			fill: hoverColor,
			opacity: 1,
			points: '672.46,387 692.5,250 662.5,0 1046,0 1076.01,250 1059.513,387'
		}, animationTime);

		customers[executable]({
			points: '333,0 363,250 333,500 0,500 0,0'
		}, animationTime);

		planning[executable]({
			points: '349.56,387 366,250 336,0 659.505,0 689.505,250 669.465,387'
		}, animationTime);

		delivery[executable]({
			points: '1382.515,500 1049,500 1079,250 1049,0 1382.515,0 1412.515,250'
		}, animationTime);

		figures[executable]({
			points: '349.31,390 1059.1,390 1046,500 336,500'
		}, animationTime);

		$('.execution-text').addClass('active');
	};

	var deactivateExecution = function deactivateExecution() {
		$('.execution-text').removeClass('active');
	};

	var activateDelivery = function activateDelivery() {
		delivery[executable]({
			fill: hoverColor,
			opacity: 1,
			points: '1382.515,500 999,500 1029,250 999,0 1382.515,0 1412.515,250'
		}, animationTime);

		customers[executable]({
			points: '333,0 363,250 333,500 0,500 0,0'
		}, animationTime);

		planning[executable]({
			points: '349.56,387 366,250 336,0 669.505,0 699.505,250 679.465,387'
		}, animationTime);

		execution[executable]({
			points: '682.46,387 702.5,250 672.5,0 996,0 1026.01,250 1009.513,387'
		}, animationTime);

		figures[executable]({
			points: '349.31,390 1009.1,390 996,500 336,500'
		}, animationTime);

		$('.delivery-triple').addClass('active');

		$('.planning-text').addClass('toleft');
		$('.execution-text').addClass('toleft');
		$('.figures-text').addClass('toleft');
	};

	var deactivateDelivery = function deactivateDelivery() {
		$('.delivery-triple').removeClass('active');

		$('.planning-text').removeClass('toleft');
		$('.execution-text').removeClass('toleft');
		$('.figures-text').removeClass('toleft');
	};

	var activateFigures = function activateFigures() {
		figures[executable]({
			fill: hoverColor,
			opacity: 1
		}, animationTime);

		$('.figures-text').addClass('active');
	};

	var activateServices = function activateServices() {
		services[executable]({
			fill: hoverColor,
			opacity: 1
		}, animationTime);

		$('.services-text').addClass('active');
	};

	init();return api;
};

app.ext['videoslider'] = function ($el) {
	var api = {};

	var swiper = void 0;

	var init = function init() {
		swiper = new Swiper('.js-videoslider.swiper-container', {
			slidesPerView: 'auto',
			spaceBetween: 30,
			loop: false,
			centeredSlides: false,
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			on: {
				slideChangeTransitionStart: function slideChangeTransitionStart() {
					this.pagination.render();
					this.pagination.update();
				}
			}
		});
	};

	init();return api;
};